@if (sparDataLoaded) {
  <div id="approvalForm" style="height: auto">
    @if (showErrorsDisclaimer) {
      <div id="errorDisclaimerID" style="margin-top: 2.625rem" class="errorDisclaimer">
        <img src="assets/error.svg" />
        <span> There are errors on the form. Please fix the errors in order to continue. </span>
      </div>
    }
    @if (showMaterialHardwareOnlyErrorDisclaimer) {
      <div
        style="margin-top: 2.625rem"
        id="materialHardwareErrorDisclaimerID"
        class="errorDisclaimer"
      >
        <img src="assets/error.svg" />
        <span>
          A Hardware Only form must have at least one row in the materials section that is a CAP
          row. Please add a CAP material record to continue.
        </span>
      </div>
    }
    @if (showMaterialHardwareSoftwareErrorDisclaimer) {
      <div
        style="margin-top: 2.625rem"
        id="materialHardwareErrorDisclaimerID"
        class="errorDisclaimer"
      >
        <img src="assets/error.svg" />
        <span>
          A Hardware and Software form needs at least one row in the Materials section that is a
          Hardware CAP row, and at least one row additional row in either the Materials or Labor
          section that is a Software CAP row.
        </span>
      </div>
    }
    @if (showMaterialSoftwareOnlyErrorDisclaimer) {
      <div
        style="margin-top: 2.625rem"
        id="materialSoftwareErrorDisclaimerID"
        class="errorDisclaimer"
      >
        <img src="assets/error.svg" />
        <span>
          A Software Only form must have at least one CAP row in either the Materials or Labor
          section. Please add a CAP material or CAP labor record to continue.
        </span>
      </div>
    }
    @if (showMaterialOmOnlyErrorDisclaimer) {
      <div
        style="margin-top: 2.625rem"
        id="materialOmOnlyErrorDisclaimerID"
        class="errorDisclaimer"
      >
        <img src="assets/error.svg" />
        <span>
          An O&M form must have at least one row in either the Materials or Labor section. Please
          add a material or labor record to continue.
        </span>
      </div>
    }
    @if (showDerivationError) {
      <div style="margin-top: 2.625rem" id="derivationErrorID" class="errorDisclaimer">
        <img src="assets/error.svg" />
        <span>
          Config corrections are needed before form can be approved. See specific messages in red
          below that indicate corrections are required before proceeding.
        </span>
      </div>
    }
    <div style="display: inline-block; width: 60%; margin-left: 4%; margin-top: 2.625rem">
      <div class="form-status-container">
        <div class="form-status-column">
          @if (displayRevisionNumber === 0) {
            <span class="itProjectHeader" style="font-size: 1.313rem">Form #{{ formNumber }}</span>
          }
          @if (displayRevisionNumber > 0) {
            <span class="itProjectHeader" style="font-size: 1.313rem"
              >Form #{{ formNumber }}, Rev {{ displayRevisionNumber }}</span
            >
          }
        </div>
        <div class="form-status-column p-0">
          @if (formStatus === 'ET&S PAC Review') {
            <span style="width: 9rem" class="form-status text-grey">ITPAC Review</span>
          }
          @if (formStatus === 'Lead ET&S PAC Review') {
            <span style="width: 9.125rem" class="form-status text-grey">Lead ITPAC Review</span>
          }
          @if (formStatus === 'Asset Accounting Review') {
            <span style="width: 11.875rem" class="form-status text-grey"
              >Asset Accounting Review</span
            >
          }
          @if (formStatus === 'IT Sponsor Review') {
            <span style="width: 9rem" class="form-status text-grey">Sponsor Review</span>
          }
          @if (formStatus === 'Joint Owner Review') {
            <span style="width: 9.125rem" class="form-status text-grey">Joint Owner Review</span>
          }
          @if (formStatus.startsWith('DOA Review')) {
            <span style="width: 6.688rem" class="form-status text-grey">DOA Review</span>
          }
          @if (formStatus === 'Approved') {
            <div
              style="
                display: inline-block;
                margin-left: 1rem;
                background: #00853f 0% 0% no-repeat padding-box;
                border-radius: 8px;
                opacity: 1;
                width: 5.75rem;
                text-align: center;
                border: 1px solid #00853f;
              "
            >
              <span style="color: #ffffff; font-size: 0.875rem">Approved</span>
            </div>
          }
          @if (formStatus === 'Approved, Rejected by Joint Owners') {
            <div
              style="
                display: inline-block;
                margin-left: 1rem;
                background: #00853f 0% 0% no-repeat padding-box;
                border-radius: 8px;
                opacity: 1;
                width: 14.75rem;
                text-align: center;
                border: 1px solid #00853f;
              "
            >
              <span style="color: #ffffff; font-size: 0.875rem"
                >Approved, Rejected by Joint Owners</span
              >
            </div>
          }
          @if (formStatus === 'Completed') {
            <div
              style="
                display: inline-block;
                margin-left: 1rem;
                background: #696969 0% 0% no-repeat padding-box;
                border-radius: 8px;
                opacity: 1;
                width: 6.25rem;
                text-align: center;
                border: 1px solid #696969;
              "
            >
              <span style="color: #ffffff; font-size: 0.875rem">Completed</span>
            </div>
          }
          @if (formStatus === 'Completed, Rejected by Joint Owners') {
            <div
              style="
                display: inline-block;
                margin-left: 1rem;
                background: #696969 0% 0% no-repeat padding-box;
                border-radius: 8px;
                opacity: 1;
                width: 15.25rem;
                text-align: center;
                border: 1px solid #696969;
              "
            >
              <span style="color: #ffffff; font-size: 0.875rem"
                >Completed, Rejected by Joint Owners</span
              >
            </div>
          }
          @if (formStatus === 'Rejected') {
            <div
              style="
                display: inline-block;
                margin-left: 1rem;
                background: #ffffff 0% 0% no-repeat padding-box;
                border-radius: 8px;
                opacity: 1;
                width: 5.375rem;
                text-align: center;
                border: 1px solid #9e1b32;
              "
            >
              <span style="color: #9e1b32; font-size: 0.875rem">Rejected</span>
            </div>
          }
        </div>
        <div
          class="form-status-column-right"
          [class.activityClosed]="!formActivityVisible"
          style="display: inline-block; float: right"
        >
          @if (!editFormMode) {
            <button [matMenuTriggerFor]="menu" class="action-button" matTooltip="Actions">
              <mat-icon style="color: rgb(0, 120, 158)">more_vert</mat-icon>
            </button>
          }
          <mat-menu #menu="matMenu">
            @if (!editFormMode) {
              <button mat-menu-item (click)="generatePDF()">
                <span>Print Form</span>
              </button>
            }
            @if (!editFormMode && canEditForm()) {
              <button mat-menu-item (click)="toggleEditFormMode()">
                <span>Edit Form</span>
              </button>
            }
            @if (
              !editFormMode &&
              !(formCompleted() || youCompleted()) &&
              (isFormOwner() || isPACUser())
            ) {
              <button mat-menu-item (click)="openDeleteConfirmationDialog()">
                <span>Delete Form</span>
              </button>
            }
          </mat-menu>
          @if (editFormMode) {
            <button
              (click)="saveForm(projectSetupForm, projectEstimateForm)"
              class="confirmButton"
              style="width: 8.125rem; margin-right: 0.938rem"
              type="submit"
            >
              <span class="confirmText">SAVE FORM</span>
            </button>
          }
          @if (editFormMode) {
            <div
              (click)="cancelEdit()"
              class="exitButton"
              style="width: 5.125rem; margin-right: 0.938rem"
            >
              <span class="exitText">CANCEL</span>
            </div>
          }
          @if (youCompleted() || formCompleted()) {
            <div
              (click)="
                !canCreateRevisionFromCurrentView()
                  ? goToLatestRevisionInProgress()
                  : createRevision()
              "
              class="exitButton"
              style="margin-right: 0.938rem; width: 16rem"
            >
              <span class="exitText">{{
                !canCreateRevisionFromCurrentView()
                  ? hasOpenRevisionDraft
                    ? 'Revision In Progress - View Current'
                    : 'View Revision'
                  : 'Create Revision'
              }}</span>
            </div>
          }
          <div class="exitButton" (click)="toggleFormActivity()">
            <span class="exitText">ACTIVITY</span>
          </div>
        </div>
      </div>
      @if (formNumbersRunningOut()) {
        <div style="width: 35.5rem; color: darkred">
          <span style="font-size: 0.75rem"
            >PaTI ID {{ patiProject.Project_ID }} is within 10 of running out of numbers to assign
            to an ARF form. Please create a replacement and be sure the description is identical.
            (Otherwise users will be able to keep choosing this one.)</span
          >
        </div>
      }
      <div
        [class.activityClosedBorder]="!formActivityVisible"
        style="height: 0.1rem; background-color: #f5f5f5; margin-top: 2.063rem; margin-left: -4rem"
      ></div>
      @if (isPACUser()) {
        <div style="margin-top: 2.625rem">
          <span class="itProjectHeader" style="font-size: 1.313rem">Form Admin</span>
        </div>
      }
      @if (isPACUser()) {
        <div style="margin-bottom: 0.2rem">
          <div style="display: inline-block; margin-right: 7.25rem; white-space: nowrap">
            <span class="headerText">Form Owner</span>
          </div>
          <div style="display: inline-block; margin-right: 3.375rem; white-space: nowrap">
            <span class="headerText">ITPAC Assignment</span>
          </div>
          @if (!(youCompleted() || formCompleted())) {
            <div style="display: inline-block; white-space: nowrap">
              <span class="headerText">Current Assignment</span>
            </div>
          }
        </div>
      }
      @if (isPACUser() && !(youCompleted() || formCompleted())) {
        <div>
          <div style="display: inline-block; width: 12.145rem">
            @if (formOwner && formOwner.givenName && formOwner.surname) {
              <span (click)="launchAssignmentDialog()" class="subHeaderText" style="cursor: pointer"
                >{{ formOwner.givenName }} {{ formOwner.surname }}</span
              >
            }
            @if (formOwner && !(formOwner.givenName && formOwner.surname)) {
              <span
                (click)="launchAssignmentDialog()"
                class="subHeaderText"
                style="cursor: pointer"
                >{{ formOwner.displayName }}</span
              >
            }
            <img
              (click)="launchAssignmentDialog()"
              style="width: 1rem; margin-left: 0.2rem; cursor: pointer"
              src="assets/review-edit.svg"
            />
          </div>
          <div style="display: inline-block; width: 10.61rem">
            @if (etsPacAssignment && etsPacAssignment.givenName && etsPacAssignment.surname) {
              <span (click)="launchAssignmentDialog()" class="subHeaderText" style="cursor: pointer"
                >{{ etsPacAssignment.givenName }} {{ etsPacAssignment.surname }}</span
              >
            }
            @if (etsPacAssignment && !(etsPacAssignment.givenName && etsPacAssignment.surname)) {
              <span
                (click)="launchAssignmentDialog()"
                class="subHeaderText"
                style="cursor: pointer"
                >{{ etsPacAssignment.displayName }}</span
              >
            }
            <img
              (click)="launchAssignmentDialog()"
              style="width: 1rem; margin-left: 0.2rem; cursor: pointer"
              src="assets/review-edit.svg"
            />
          </div>
          <div style="display: inline-block; width: 12.313rem">
            @if (currentAssignment && currentAssignment.givenName && currentAssignment.surname) {
              <span (click)="launchAssignmentDialog()" class="subHeaderText" style="cursor: pointer"
                >{{ currentAssignment.givenName }} {{ currentAssignment.surname }}</span
              >
            }
            @if (currentAssignment && !(currentAssignment.givenName && currentAssignment.surname)) {
              <span
                (click)="launchAssignmentDialog()"
                class="subHeaderText"
                style="cursor: pointer"
                >{{ currentAssignment.displayName }}</span
              >
            }
            <img
              (click)="launchAssignmentDialog()"
              style="width: 1rem; margin-left: 0.2rem; cursor: pointer"
              src="assets/review-edit.svg"
            />
          </div>
          <div style="display: inline-block; width: 30rem">
            <img
              (click)="launchApproverDialog()"
              style="cursor: pointer; width: 1.125rem; margin-right: 0.125rem"
              src="assets/manage-approvers.svg"
            />
            <span
              (click)="launchApproverDialog()"
              class="subHeaderText"
              style="cursor: pointer; white-space: nowrap"
              >Manage DOA Approvers</span
            >
          </div>
        </div>
      }
      @if (isPACUser() && (youCompleted() || formCompleted())) {
        <div>
          <div style="display: inline-block; width: 12.145rem">
            @if (formOwner && formOwner.givenName && formOwner.surname) {
              <span class="subHeaderText" style="color: #4c4c4c; text-decoration: none"
                >{{ formOwner.givenName }} {{ formOwner.surname }}</span
              >
            }
            @if (formOwner && !(formOwner.givenName && formOwner.surname)) {
              <span class="subHeaderText" style="color: #4c4c4c; text-decoration: none">{{
                formOwner.displayName
              }}</span>
            }
          </div>
          <div style="display: inline-block; width: 10.61rem">
            @if (etsPacAssignment && etsPacAssignment.givenName && etsPacAssignment.surname) {
              <span class="subHeaderText" style="color: #4c4c4c; text-decoration: none"
                >{{ etsPacAssignment.givenName }} {{ etsPacAssignment.surname }}</span
              >
            }
            @if (etsPacAssignment && !(etsPacAssignment.givenName && etsPacAssignment.surname)) {
              <span class="subHeaderText" style="color: #4c4c4c; text-decoration: none">{{
                etsPacAssignment.displayName
              }}</span>
            }
          </div>
          <div style="display: inline-block; width: 12.313rem">
            @if (currentAssignment && currentAssignment.givenName && currentAssignment.surname) {
              <span class="subHeaderText" style="color: #4c4c4c; text-decoration: none"
                >{{ currentAssignment.givenName }} {{ currentAssignment.surname }}</span
              >
            }
            @if (currentAssignment && !(currentAssignment.givenName && currentAssignment.surname)) {
              <span class="subHeaderText" style="color: #4c4c4c; text-decoration: none">{{
                currentAssignment.displayName
              }}</span>
            }
          </div>
        </div>
      }
      @if (tables) {
        <div style="margin-top: 2.625rem">
          <span class="itProjectHeader" style="font-size: 1.313rem">Notes from ITPAC</span>
        </div>
      }
      @if (tables) {
        <section id="tableSection" class="content_container">
          <div class="effective_date_picker">
            <span class="effectiveDateText">Effective Date</span>
            <mat-form-field>
              <input
                matInput
                [matDatepicker]="effectiveDatePicker"
                [(ngModel)]="effectiveDate"
                style="color: #696969"
              />
              <mat-datepicker-toggle matSuffix [for]="effectiveDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #effectiveDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          @for (table of tables; track table; let tableIndex = $index) {
            <div class="table_container">
              <input
                matInput
                class="table_name_input"
                placeholder="Table Name"
                [value]="tables[tableIndex].tableName"
              />
              <div class="table_wrapper">
                <table mat-table [dataSource]="table.tableData" class="detail-table">
                  @for (
                    column of getColumnDefs(tableIndex);
                    track column;
                    let columnIndex = $index
                  ) {
                    <ng-container [matColumnDef]="column">
                      <th class="detailTableTh" mat-header-cell *matHeaderCellDef>
                        <input
                          matInput
                          class="table_column_name_input"
                          [value]="table.columns[columnIndex].colName"
                        />
                      </th>
                      <td
                        class="detailTableTd"
                        mat-cell
                        *matCellDef="let element; let rowIndex = index"
                      >
                        <input
                          matInput
                          class="table_row_name_input"
                          [value]="getRowValue(tableIndex, rowIndex, columnIndex)"
                        />
                      </td>
                    </ng-container>
                  }
                  <tr mat-header-row *matHeaderRowDef="getColumnDefs(tableIndex)"></tr>
                  <tr mat-row *matRowDef="let row; columns: getColumnDefs(tableIndex)"></tr>
                </table>
              </div>
            </div>
          }
        </section>
      }
      <form #projectSetupForm="ngForm" (keydown.enter)="$event.preventDefault()">
        <div style="margin-top: 2.625rem">
          <span class="itProjectHeader" style="font-size: 1.313rem">Page One</span>
        </div>
        <div style="margin-top: 1.5rem; display: flex">
          <div style="width: 34rem; height: 6.25rem">
            <div style="display: inline-block; margin-top: 1.125rem">
              <mat-form-field class="itFields" style="width: 30rem">
                <input
                  matInput
                  readonly="true"
                  placeholder="PaTI ID #"
                  [(ngModel)]="displayPatiProject"
                  name="displayPatiProject"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div style="display: flex">
          <div style="margin-top: 1.5rem">
            @if (!editFormMode) {
              <div style="width: 23.438rem; height: 6.25rem">
                <div style="display: inline-block; margin-top: 1.125rem">
                  <mat-form-field class="itFields" style="width: 19.4rem" [floatLabel]="'always'">
                    <input
                      maxlength="35"
                      readonly="true"
                      [(ngModel)]="projectName"
                      placeholder="Short Description (Max 35 Characters)"
                      matInput
                      name="projectName"
                    />
                  </mat-form-field>
                </div>
              </div>
            }
            @if (editFormMode) {
              <div style="width: 23.438rem; height: 6.25rem; background-color: #f3fafd">
                <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                  <mat-form-field
                    class="itFields"
                    style="width: 19.4rem; padding-left: 0.5rem; padding-right: 0.5rem"
                  >
                    <input
                      maxlength="35"
                      [(ngModel)]="projectNameCopy"
                      placeholder="Short Description (Max 35 Characters)"
                      matInput
                      required
                      name="shortDescField"
                    />
                  </mat-form-field>
                </div>
              </div>
            }
          </div>
          <div style="display: inline-block; margin-top: 1.5rem">
            @if (!editFormMode) {
              <div style="width: 23.438rem; height: 6.25rem">
                <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                  <mat-form-field class="itFields" style="width: 19.4rem">
                    <input
                      placeholder="IT Project Classification"
                      readonly="true"
                      matInput
                      [(ngModel)]="itProjectClassification.ets_proj_classification"
                      name="ets_proj_classification"
                    />
                  </mat-form-field>
                </div>
              </div>
            }
            @if (editFormMode) {
              <div style="width: 23.438rem; height: 6.25rem; background-color: #f3fafd">
                <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                  <mat-form-field
                    class="itFields"
                    style="width: 19.4rem; padding-left: 0.5rem; padding-right: 0.5rem"
                  >
                    <mat-select
                      [(ngModel)]="itProjectClassificationCopy"
                      placeholder="IT Project Classification"
                      required
                      name="classificationField"
                      [compareWith]="compareItProjectClassification"
                    >
                      @for (option of itProjectClassificationOptions; track option) {
                        <mat-option style="color: #696969" [value]="option"
                          ><span>{{ option.ets_proj_classification }}</span></mat-option
                        >
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            }
          </div>
        </div>
        <div style="margin-top: 1.5rem; margin-right: 1.5rem">
          @if (!editFormMode) {
            <div style="width: 48.375rem; height: 6.25rem">
              <mat-form-field
                style="
                  background: white;
                  padding-right: 1.5rem;
                  margin-top: 1.125rem;
                  width: 21.438rem;
                  height: 4rem;
                "
              >
                <mat-label>Estimated Start Date</mat-label>
                <input
                  matInput
                  readonly="true"
                  #datepickerInput1
                  [matDatepicker]="startDatePicker"
                  [(ngModel)]="estimatedStartDate"
                  style="color: #696969"
                  name="estimatedStartDate"
                />
                <mat-datepicker #startDatePicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field
                style="
                  background: white;
                  padding-left: 0.4rem;
                  padding-right: 0.4rem;
                  margin-left: 1.5rem;
                  width: 21.438rem;
                  height: 4rem;
                "
              >
                <mat-label>Estimated In Service Date</mat-label>
                <input
                  matInput
                  readonly="true"
                  #datepickerInput2
                  [matDatepicker]="inServiceDatePicker"
                  [(ngModel)]="estimatedInServiceDate"
                  style="color: #696969"
                  name="estimatedInServiceDate"
                />
                <mat-datepicker #inServiceDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          }
          @if (editFormMode) {
            <div style="width: 48.375rem; height: 6.25rem; background-color: #f3fafd">
              <mat-form-field
                style="
                  background: white;
                  padding-left: 0.4rem;
                  padding-right: 0.4rem;
                  margin-top: 1.125rem;
                  margin-left: 1.5rem;
                  width: 21.438rem;
                  height: 4rem;
                "
              >
                <mat-label>Estimated Start Date</mat-label>
                <input
                  matInput
                  #datepickerInput1
                  [matDatepicker]="startDatePicker"
                  [(ngModel)]="estimatedStartDateCopy"
                  style="color: #696969"
                  [max]="estimatedInServiceDateCopy"
                  (dateChange)="onStartDateChange()"
                  required
                  name="estimatedStartDateField"
                />
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field
                style="
                  background: white;
                  padding-left: 0.4rem;
                  padding-right: 0.4rem;
                  margin-left: 1.5rem;
                  width: 21.438rem;
                  height: 4rem;
                "
              >
                <mat-label>Estimated In Service Date</mat-label>
                <input
                  matInput
                  #datepickerInput2
                  [matDatepicker]="inServiceDatePicker"
                  [(ngModel)]="estimatedInServiceDateCopy"
                  [min]="minimumInServiceDate()"
                  style="color: #696969"
                  (dateChange)="onInServiceDateChange()"
                  required
                  name="estimatedInServiceDateField"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="inServiceDatePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #inServiceDatePicker></mat-datepicker>
              </mat-form-field>
            </div>
          }
        </div>
        <div style="margin-top: 1.5rem">
          <span
            class="projectScopeHeader"
            [style.color]="
              projectSetupForm.controls['projectScopeDescriptionField']?.touched &&
              projectSetupForm.controls['projectScopeDescriptionField']?.errors?.required
                ? '#9e1b32'
                : ''
            "
            >Overview and Scope</span
          >
        </div>
        <div style="margin-top: 0.688rem">
          @if (!editFormMode) {
            <div class="p-1 grey-border text-grey width-60">
              {{ projectScopeDescription }}
            </div>
          }
          @if (editFormMode) {
            <textarea
              [style.border]="
                projectSetupForm.controls['projectScopeDescriptionField']?.touched &&
                projectSetupForm.controls['projectScopeDescriptionField']?.errors?.required
                  ? '1px solid #9e1b32'
                  : '1px solid #26bcd7'
              "
              [(ngModel)]="projectScopeDescriptionCopy"
              class="scopeDescriptionTextBox"
              maxlength="255"
              required
              name="projectScopeDescriptionField"
            ></textarea>
          }
        </div>
        <div style="margin-top: 1.5rem">
          <span class="projectScopeHeader">Contacts</span>
        </div>
        <div style="margin-top: 0.688rem">
          @if (!editFormMode) {
            <div style="width: 66.375rem; height: 6.25rem">
              <mat-form-field
                class="itFields"
                style="margin-top: 1.125rem; width: 55.638rem; height: 4rem"
              >
                <input
                  readonly="true"
                  name="primaryContact"
                  type="text"
                  placeholder="Primary Contact"
                  matInput
                  [(ngModel)]="displayPrimaryContact"
                />
              </mat-form-field>
            </div>
          }
          @if (editFormMode) {
            <div style="width: 66.375rem; height: 6.25rem; background-color: #f3fafd">
              @if (!(primaryContactCopy && primaryContactCopy.mail)) {
                <mat-form-field
                  class="itFields"
                  style="
                    margin-top: 1.125rem;
                    margin-left: 1.5rem;
                    width: 55.638rem;
                    height: 4rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    name="primaryContactField"
                    type="text"
                    placeholder="Primary Contact (Search for a name and then make a selection)"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto1"
                    [formControl]="primaryContactControl"
                    [(ngModel)]="primaryContactCopy"
                    required
                    (keydown.enter)="searchUsersPrimaryContact($event.target.value)"
                  />
                </mat-form-field>
              }
              @if (primaryContactCopy && primaryContactCopy.mail) {
                <mat-form-field
                  class="itFields"
                  style="
                    margin-top: 1.125rem;
                    margin-left: 1.5rem;
                    width: 55.638rem;
                    height: 4rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    name="primaryContactField"
                    type="text"
                    placeholder="Primary Contact (Search for a name and then make a selection)"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto1"
                    [formControl]="primaryContactControl"
                    [(ngModel)]="primaryContactCopy"
                    readonly="true"
                  />
                </mat-form-field>
              }
              <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayFnPrimaryContact">
                @for (option of primaryContactOptions; track option) {
                  <mat-option style="color: #696969" [value]="option">
                    @if (option.givenName && option.surname && option.jobTitle) {
                      <span
                        >{{ option.givenName }} {{ option.surname }} ({{ option.mail }}),
                        {{ option.jobTitle }}</span
                      >
                    }
                    @if (option.givenName && option.surname && !option.jobTitle) {
                      <span>{{ option.givenName }} {{ option.surname }} ({{ option.mail }})</span>
                    }
                    @if (!(option.givenName && option.surname) && option.jobTitle) {
                      <span
                        >{{ option.displayName }} ({{ option.mail }}), {{ option.jobTitle }}</span
                      >
                    }
                    @if (!(option.givenName && option.surname) && !option.jobTitle) {
                      <span>{{ option.displayName }} ({{ option.mail }})</span>
                    }
                  </mat-option>
                }
              </mat-autocomplete>
              @if (primaryContactCopy && primaryContactCopy.mail) {
                <div
                  style="
                    display: inline-block;
                    padding-top: 1.813rem;
                    z-index: 0;
                    position: absolute;
                  "
                >
                  <img
                    (click)="deletePrimaryContact()"
                    style="margin-left: -1.5rem; cursor: pointer"
                    src="assets/close-window.svg"
                  />
                </div>
              }
              <div style="display: inline-block; margin-left: 0.938rem">
                <button
                  class="confirmButton"
                  type="button"
                  style="width: 5rem"
                  (click)="searchUsersPrimaryContact(primaryContactCopy)"
                >
                  <span class="confirmText">SEARCH</span>
                </button>
              </div>
            </div>
          }
        </div>
        <div style="margin-top: 0.688rem">
          @if (!editFormMode) {
            <div style="width: 66.375rem; height: 6.25rem">
              <mat-form-field
                class="itFields"
                style="margin-top: 1.125rem; width: 55.638rem; height: 4rem"
              >
                <input
                  readonly="true"
                  name="itSponsor"
                  type="text"
                  placeholder="Sponsor"
                  matInput
                  [(ngModel)]="displayItSponsor"
                  name="displayItSponsor"
                />
              </mat-form-field>
            </div>
          }
          @if (editFormMode) {
            <div style="width: 66.375rem; height: 6.25rem; background-color: #f3fafd">
              @if (!(itSponsorCopy && itSponsorCopy.mail)) {
                <mat-form-field
                  class="itFields"
                  style="
                    margin-top: 1.125rem;
                    margin-left: 1.5rem;
                    width: 55.638rem;
                    height: 4rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    name="itSponsorField"
                    type="text"
                    placeholder="Sponsor (Search for a name and then make a selection)"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto2"
                    [formControl]="itSponsorControl"
                    [(ngModel)]="itSponsorCopy"
                    (keydown.enter)="searchUsersItSponsor($event.target.value)"
                    required
                  />
                </mat-form-field>
              }
              @if (itSponsorCopy && itSponsorCopy.mail) {
                <mat-form-field
                  class="itFields"
                  style="
                    margin-top: 1.125rem;
                    margin-left: 1.5rem;
                    width: 55.638rem;
                    height: 4rem;
                    padding-left: 0.5rem;
                    padding-right: 0.5rem;
                  "
                >
                  <input
                    name="itSponsor"
                    type="text"
                    placeholder="Sponsor (Search for a name and then make a selection)"
                    matAutocompletePosition="below"
                    matInput
                    [matAutocomplete]="auto2"
                    [formControl]="itSponsorControl"
                    [(ngModel)]="itSponsorCopy"
                    readonly="true"
                  />
                </mat-form-field>
              }
              <mat-autocomplete
                #auto2="matAutocomplete"
                [displayWith]="displayFnITSponsor"
                (optionSelected)="getDOA($event.option.value.mailNickname, 0, true)"
              >
                @for (option of itSponsorOptions; track option) {
                  <mat-option style="color: #696969" [value]="option">
                    @if (option.givenName && option.surname && option.jobTitle) {
                      <span
                        >{{ option.givenName }} {{ option.surname }} ({{ option.mail }}),
                        {{ option.jobTitle }}</span
                      >
                    }
                    @if (option.givenName && option.surname && !option.jobTitle) {
                      <span>{{ option.givenName }} {{ option.surname }} ({{ option.mail }})</span>
                    }
                    @if (!(option.givenName && option.surname) && option.jobTitle) {
                      <span
                        >{{ option.displayName }} ({{ option.mail }}), {{ option.jobTitle }}</span
                      >
                    }
                    @if (!(option.givenName && option.surname) && !option.jobTitle) {
                      <span>{{ option.displayName }} ({{ option.mail }})</span>
                    }
                  </mat-option>
                }
              </mat-autocomplete>
              @if (itSponsorCopy && itSponsorCopy.mail) {
                <div
                  style="
                    display: inline-block;
                    padding-top: 1.813rem;
                    z-index: 0;
                    position: absolute;
                  "
                >
                  <img
                    (click)="deleteITSponsor()"
                    style="margin-left: -1.5rem; cursor: pointer"
                    src="assets/close-window.svg"
                  />
                </div>
              }
              <div style="display: inline-block; margin-left: 0.938rem">
                <button
                  class="confirmButton"
                  type="button"
                  style="width: 5rem"
                  (click)="searchUsersItSponsor(itSponsorCopy)"
                >
                  <span class="confirmText">SEARCH</span>
                </button>
              </div>
            </div>
          }
        </div>
        @if (!editFormMode) {
          <div>
            <div style="display: flex; gap: 1rem; color: dimgray">
              <span>Is this request O&M only?</span>
              <mat-radio-group [(ngModel)]="omOnly" name="omOnlyField" disabled>
                <mat-radio-button color="primary" [value]="'YES'">
                  <span class="choiceText">YES</span>
                </mat-radio-button>
                <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                  <span class="choiceText">NO</span>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        }
        @if (editFormMode) {
          <div
            style="
              width: fit-content;
              background-color: #f3fafd;
              margin-top: 1.5rem;
              padding: 1rem 1.5rem;
            "
          >
            <div
              style="
                display: flex;
                gap: 1rem;
                color: dimgray;
                padding: 0.5rem;
                background-color: white;
              "
            >
              <span
                [style.color]="
                  projectSetupForm.submitted &&
                  projectSetupForm.controls['omOnlyField']?.errors?.required
                    ? '#9e1b32'
                    : ''
                "
                >Is this request O&M only?</span
              >
              <mat-radio-group
                [(ngModel)]="omOnlyCopy"
                required
                name="omOnlyField"
                (change)="omOnlyChanged()"
              >
                <mat-radio-button color="primary" [value]="'YES'">
                  <span class="choiceText">YES</span>
                </mat-radio-button>
                <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                  <span class="choiceText">NO</span>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        }
        <div style="margin-top: 1.5rem">
          <div style="width: 24.438rem; height: 6.25rem">
            <div style="display: inline-block; margin-top: 1.125rem">
              @if (!editFormMode) {
                <mat-form-field class="itFields" style="width: 20.4rem">
                  <input
                    readonly="true"
                    type="text"
                    placeholder="Does this work relate to:"
                    matInput
                    [(ngModel)]="relatedWork"
                    name="relatedWorkField"
                  />
                </mat-form-field>
              }
              @if (editFormMode) {
                <mat-form-field class="itFields" style="width: 20.4rem">
                  <mat-select
                    [(ngModel)]="relatedWorkCopy"
                    placeholder="Does this work relate to:"
                    (selectionChange)="relatedWorkChanged()"
                    required
                    name="relatedWorkField"
                  >
                    @for (option of hardwareOrSoftwareOptions; track option) {
                      <mat-option style="color: #696969" [value]="option"
                        ><span>{{ option }}</span></mat-option
                      >
                    }
                  </mat-select>
                </mat-form-field>
              }
            </div>
          </div>
        </div>
        @if (
          hardwareOrSoftwareCopy === 'Hardware Only' ||
          hardwareOrSoftwareCopy === 'Hardware and Software'
        ) {
          <div>
            <div style="margin-top: 1.5rem">
              <span class="projectScopeHeader">Hardware Details</span>
            </div>
            <div style="margin-top: 0.688rem">
              @if (!editFormMode) {
                <div style="width: 73.25rem">
                  <div style="position: relative">
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-bottom: 1.5rem;
                        width: 34.438rem;
                      "
                    >
                      <span class="bodyText"
                        >Are you purchasing any service warranties? (If yes, the cost of service
                        warranties should be included in O&M estimate; none of this cost can be
                        capitalized)</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 7.375rem;
                        vertical-align: top;
                        position: absolute;
                        top: 0.625rem;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="purchasingWarrantiesCopy"
                        disabled
                        name="purchasingWarrantiesCopy"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">YES</mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                          >NO</mat-radio-button
                        >
                      </mat-radio-group>
                    </div>
                  </div>
                </div>
              }
              @if (editFormMode) {
                <div style="width: 73.25rem; background-color: #f3fafd">
                  <div style="position: relative">
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 1.5rem;
                        margin-bottom: 1.5rem;
                        width: 34.438rem;
                      "
                    >
                      <span
                        class="bodyText"
                        [style.color]="
                          projectSetupForm.controls['purchasingWarrantiesField']?.touched &&
                          projectSetupForm.controls['purchasingWarrantiesField']?.errors?.required
                            ? '#9e1b32'
                            : ''
                        "
                        >Are you purchasing any service warranties? (If yes, the cost of service
                        warranties should be included in O&M estimate; none of this cost can be
                        capitalized)</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 7.375rem;
                        vertical-align: top;
                        position: absolute;
                        top: 0.625rem;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="purchasingWarrantiesCopy"
                        required
                        name="purchasingWarrantiesField"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @if (
          hardwareOrSoftwareCopy === 'Software Only' ||
          hardwareOrSoftwareCopy === 'Hardware and Software'
        ) {
          <div>
            <div style="margin-top: 1.5rem">
              <span class="projectScopeHeader">Software Details</span>
            </div>
            <div style="margin-top: 0.688rem">
              @if (!editFormMode) {
                <div style="width: 73.25rem">
                  <div style="padding-top: 1rem">
                    <span style="color: gray"
                      >Work consists of the following: (Select all that apply)</span
                    >
                    @for (option of projectConsistsOfOptions; track option; let i = $index) {
                      <div style="text-align: left; margin-bottom: 0.938rem">
                        <mat-checkbox
                          color="primary"
                          disabled
                          [checked]="projectConsistsOfCheckboxes[i]"
                        >
                          <span style="color: #696969; white-space: normal">{{ option }}</span>
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                  <div>
                    <div style="display: inline-block; margin-top: 1.5rem">
                      <mat-form-field
                        class="itFields"
                        style="width: 20.4rem"
                        [floatLabel]="'always'"
                      >
                        <input
                          type="number"
                          step="1"
                          min="0"
                          [(ngModel)]="expectedLife"
                          placeholder="What is the expected life of the software (years)?"
                          oninput="
                            this.value =
                              !!this.value && Math.abs(this.value) >= 0
                                ? Math.abs(this.value)
                                : null
                          "
                          matInput
                          required
                          name="expectedLifeField"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="position: relative">
                    <div style="display: inline-block; margin-top: 1.5rem; width: 34.438rem">
                      <span class="bodyText">Is this an Agile effort?</span>
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 7.375rem;
                        vertical-align: top;
                        position: absolute;
                        top: 0.625rem;
                      "
                    >
                      <mat-radio-group [(ngModel)]="agileEffort" disabled name="agileEffor">
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  <div style="position: relative">
                    <div style="display: inline-block; margin-top: 1.5rem; width: 34.438rem">
                      <span class="bodyText"
                        >Does the software currently exist or is it being used for any other
                        jurisdictions, department, business unit, or function?</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 7.375rem;
                        vertical-align: top;
                        position: absolute;
                        top: 0.625rem;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="softwareBeingUsed"
                        disabled
                        name="softwareBeingUsed"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  <div>
                    <div style="display: inline-block; margin-top: 1.5rem">
                      <mat-form-field class="itFields" style="width: 19.4rem">
                        <input
                          readonly="true"
                          [(ngModel)]="vendorName"
                          placeholder="Vendor Name (Optional)"
                          matInput
                          name="vendorName"
                        />
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.5rem; margin-left: 1.5rem">
                      <mat-form-field class="itFields" style="width: 19.4rem">
                        <input
                          readonly="true"
                          [(ngModel)]="softwareName"
                          placeholder="Software Name"
                          matInput
                          name="softwareName"
                        />
                      </mat-form-field>
                    </div>
                    <div
                      [class.hideText]="softwareBeingUsed === 'NO'"
                      style="display: inline-block; margin-top: 1.5rem; margin-left: 1.5rem"
                    >
                      <mat-form-field class="itFields" style="width: 19.4rem">
                        <input
                          readonly="true"
                          [(ngModel)]="inServiceYear"
                          placeholder="In what year did it go in service?"
                          matInput
                          name="inServiceYear"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="margin-top: 1.5rem">
                    <span class="bodyText"
                      >Describe the software development work needed for this effort:</span
                    >
                  </div>
                  <div style="margin-top: 0.688rem">
                    <textarea
                      [(ngModel)]="softwareProjectOverview"
                      name="softwareProjectOverview"
                      class="softwareProjectOverviewTextBox"
                      style="height: 4rem; width: 45.375rem"
                    ></textarea>
                  </div>
                  <div style="width: 49.438rem">
                    <div style="display: inline-block; margin-top: 1.5rem; width: 37.688rem">
                      <span class="bodyText"
                        >Will you have data conversion activities? (If yes, the cost of running
                        processes or manually cleaning up data should be included in O&M estimate;
                        only development of data conversion software can be capitalized)</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        vertical-align: top;
                        float: right;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="dataConversionActivities"
                        disabled
                        name="dataConversionActivities"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  <div style="width: 49.438rem">
                    <div style="display: inline-block; margin-top: 1.5rem; width: 37.688rem">
                      <span class="bodyText"
                        >Will you have training costs? (If yes, the cost of train-the-trainer and
                        user training should be included in O&M estimate; only developer training on
                        how to develop the software can be capitalized)</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        vertical-align: top;
                        float: right;
                      "
                    >
                      <mat-radio-group [(ngModel)]="trainingCosts" disabled name="trainingCosts">
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  <div style="width: 49.438rem">
                    <div style="display: inline-block; margin-top: 1.5rem; width: 37.688rem">
                      <span class="bodyText"
                        >Is there an associated retirement of existing software?</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        vertical-align: top;
                        float: right;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="associatedRetirement"
                        disabled
                        name="associatedRetirement"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  <div
                    [class.hideElements]="associatedRetirement !== 'YES'"
                    style="display: inline-block"
                  >
                    <div style="display: inline-block; margin-top: 0.688rem">
                      <mat-form-field class="itFields" style="width: 19.4rem">
                        <input
                          readonly="true"
                          [(ngModel)]="softwareToBeRetired"
                          placeholder="Software To Be Retired"
                          matInput
                          name="softwareToBeRetired"
                        />
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 0.688rem; margin-left: 1.5rem">
                      <mat-form-field class="itFields" style="width: 19.4rem">
                        <input
                          readonly="true"
                          [(ngModel)]="retiredInServiceDate"
                          placeholder="When was it in service?"
                          matInput
                          name="retiredInServiceDate"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="width: 49.438rem">
                    <div style="display: inline-block; margin-top: 1.5rem; width: 37.688rem">
                      <span class="bodyText"
                        >Will you have any maintenance contracts/agreements?</span
                      >
                    </div>
                    <div
                      [class.moveDown]="associatedRetirement === 'YES'"
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        vertical-align: top;
                        float: right;
                        position: relative;
                        top: -3.313rem;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="maintenanceContracts"
                        disabled
                        name="maintenanceContracts"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  <div style="width: 49.438rem">
                    <div style="display: inline-block; margin-top: 1.5rem; width: 37.688rem">
                      <span class="bodyText">Are you replacing any existing interfaces?</span>
                    </div>
                    <div
                      [class.moveLeft]="associatedRetirement === 'YES'"
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        vertical-align: top;
                        float: right;
                        position: relative;
                        top: -3.313rem;
                        left: 7.48rem;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="replacingInterfaces"
                        disabled
                        name="replacingInterfaces"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  <div>
                    <mat-form-field
                      class="itFields"
                      style="margin-top: 1.5rem; margin-bottom: 1.5rem; width: 30.938rem"
                    >
                      <input
                        required
                        type="text"
                        placeholder="How will the software be released?"
                        matInput
                        [(ngModel)]="howSoftwareReleased"
                        name="howSoftwareReleasedField"
                      />
                    </mat-form-field>
                  </div>
                  @if (isVendorHosted()) {
                    <div style="width: 49.438rem">
                      <div style="display: inline-block; width: 37.688rem">
                        <span class="bodyText">Will Duke own perpetual licenses?</span>
                      </div>
                      <div
                        style="
                          display: inline-block;
                          vertical-align: top;
                          float: right;
                          position: relative;
                        "
                      >
                        <mat-radio-group
                          [(ngModel)]="perpetualLicenses"
                          disabled
                          name="perpetualLicenses"
                        >
                          <mat-radio-button color="primary" [value]="'YES'">
                            <span class="choiceText">YES</span>
                          </mat-radio-button>
                          <mat-radio-button
                            color="primary"
                            [value]="'NO'"
                            style="margin-left: 1.125rem"
                          >
                            <span class="choiceText">NO</span>
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  }
                  @if (isVendorHosted()) {
                    <div style="width: 49.438rem">
                      <div style="display: inline-block; margin-top: 1.5rem; width: 36.688rem">
                        <span class="bodyText"
                          >Does Duke have the contractual right to take possession of the software
                          at any time during the arrangement period?</span
                        >
                      </div>
                      <div
                        style="
                          display: inline-block;
                          margin-top: 1.5rem;
                          vertical-align: top;
                          float: right;
                          position: relative;
                          top: -3.313rem;
                        "
                      >
                        <mat-radio-group
                          [(ngModel)]="contractualRight"
                          disabled
                          name="contractualRight"
                        >
                          <mat-radio-button color="primary" [value]="'YES'">
                            <span class="choiceText">YES</span>
                          </mat-radio-button>
                          <mat-radio-button
                            color="primary"
                            [value]="'NO'"
                            style="margin-left: 1.125rem"
                          >
                            <span class="choiceText">NO</span>
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  }
                  @if (isVendorHosted()) {
                    <div style="width: 49.438rem">
                      <div style="display: inline-block; margin-top: 1.5rem; width: 37.688rem">
                        <span class="bodyText"
                          >Is there a significant penalty to take possession of the software and
                          bring it in house? (Significant penalty is interpreted as either a
                          significant cost or significant reduction in value or functionality when
                          taking possession of the software. Significant cost is defined as greater
                          than 15% of the total capital cost of the project)</span
                        >
                      </div>
                      <div
                        style="
                          display: inline-block;
                          margin-top: 1.5rem;
                          vertical-align: top;
                          float: right;
                          position: relative;
                          top: -6.313rem;
                        "
                      >
                        <mat-radio-group
                          [(ngModel)]="significantPenalty"
                          disabled
                          name="significantPenalty"
                        >
                          <mat-radio-button color="primary" [value]="'YES'">
                            <span class="choiceText">YES</span>
                          </mat-radio-button>
                          <mat-radio-button
                            color="primary"
                            [value]="'NO'"
                            style="margin-left: 1.125rem"
                          >
                            <span class="choiceText">NO</span>
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  }
                  @if (isVendorHosted()) {
                    <div style="width: 49.438rem">
                      <div style="display: inline-block; margin-top: 1.5rem; width: 34.688rem">
                        <span class="bodyText"
                          >Is it feasible for Duke to run the software on our own hardware or to
                          contract with another third party host?</span
                        >
                      </div>
                      <div
                        style="
                          display: inline-block;
                          margin-top: 0.5rem;
                          vertical-align: top;
                          float: right;
                          position: relative;
                          top: -3.313rem;
                        "
                      >
                        <mat-radio-group [(ngModel)]="isFeasible" disabled name="isFeasible">
                          <mat-radio-button color="primary" [value]="'YES'">
                            <span class="choiceText">YES</span>
                          </mat-radio-button>
                          <mat-radio-button
                            color="primary"
                            [value]="'NO'"
                            style="margin-left: 1.125rem"
                          >
                            <span class="choiceText">NO</span>
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  }
                  @if (isVendorHosted()) {
                    <div style="width: 49.438rem">
                      <div style="display: inline-block; margin-top: 1.5rem; width: 37.688rem">
                        <span class="bodyText">Are there service or usage fees?</span>
                      </div>
                      <div
                        style="
                          display: inline-block;
                          margin-top: 1.5rem;
                          vertical-align: top;
                          float: right;
                          position: relative;
                          top: -3.313rem;
                        "
                      >
                        <mat-radio-group [(ngModel)]="serviceFees" disabled name="serviceFees">
                          <mat-radio-button color="primary" [value]="'YES'">
                            <span class="choiceText">YES</span>
                          </mat-radio-button>
                          <mat-radio-button
                            color="primary"
                            [value]="'NO'"
                            style="margin-left: 1.125rem"
                          >
                            <span class="choiceText">NO</span>
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  }
                  @if (isVendorHosted()) {
                    <div style="width: 49.438rem">
                      <div
                        style="
                          display: inline-block;
                          margin-top: 1.5rem;
                          margin-bottom: 1.5rem;
                          width: 37.688rem;
                        "
                      >
                        <span class="bodyText"
                          >If we stop paying the service or usage fees, can we still use the
                          software?</span
                        >
                      </div>
                      <div
                        style="
                          display: inline-block;
                          vertical-align: top;
                          float: right;
                          position: relative;
                          top: -3.313rem;
                        "
                      >
                        <mat-radio-group
                          [(ngModel)]="useWithoutPaying"
                          disabled
                          name="useWithoutPaying"
                        >
                          <mat-radio-button color="primary" [value]="'YES'">
                            <span class="choiceText">YES</span>
                          </mat-radio-button>
                          <mat-radio-button
                            color="primary"
                            [value]="'NO'"
                            style="margin-left: 1.125rem"
                          >
                            <span class="choiceText">NO</span>
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (editFormMode) {
                <div style="width: 73.25rem; background-color: #f3fafd">
                  <div style="padding-top: 1rem; padding-left: 1rem">
                    <span
                      [style.color]="
                        !(projectConsistsOfCopy && projectConsistsOfCopy.length)
                          ? '#9e1b32'
                          : 'gray'
                      "
                      >Work consists of the following: (Select all that apply)
                    </span>
                    @for (option of projectConsistsOfOptions; track option; let i = $index) {
                      <div style="text-align: left; margin-bottom: 0.938rem">
                        <mat-checkbox
                          color="primary"
                          [checked]="projectConsistsOfCheckboxesCopy[i]"
                          (change)="consistsOfChange(i, option)"
                          required
                          name="projectConsistsOfField"
                        >
                          <span style="color: #696969; white-space: normal">{{ option }}</span>
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                  <div>
                    <div style="display: inline-block; margin-top: 1.5rem; margin-left: 1.5rem">
                      <mat-form-field
                        class="itFields"
                        style="width: 19.4rem; padding-left: 0.5rem; padding-right: 0.5rem"
                        [floatLabel]="'always'"
                      >
                        <input
                          type="number"
                          step="1"
                          min="0"
                          [(ngModel)]="expectedLifeCopy"
                          placeholder="What is the expected life of the software (years)?"
                          oninput="
                            this.value =
                              !!this.value && Math.abs(this.value) >= 0
                                ? Math.abs(this.value)
                                : null
                          "
                          matInput
                          required
                          name="expectedLifeField"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                  <div style="position: relative">
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 1.5rem;
                        width: 34.438rem;
                      "
                    >
                      <span
                        class="bodyText"
                        [style.color]="
                          projectSetupForm.controls['agileEffortField']?.touched &&
                          projectSetupForm.controls['agileEffortField']?.errors?.required
                            ? '#9e1b32'
                            : ''
                        "
                        >Is this an Agile effort?</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 7.375rem;
                        vertical-align: top;
                        position: absolute;
                        top: 0.625rem;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="agileEffortCopy"
                        required
                        name="agileEffortField"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  <div style="position: relative">
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 1.5rem;
                        width: 34.438rem;
                      "
                    >
                      <span
                        class="bodyText"
                        [style.color]="
                          projectSetupForm.controls['softwareBeingUsedField']?.touched &&
                          projectSetupForm.controls['softwareBeingUsedField']?.errors?.required
                            ? '#9e1b32'
                            : ''
                        "
                        >Does the software currently exist or is it being used for any other
                        jurisdictions, department, business unit, or function?</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 7.375rem;
                        vertical-align: top;
                        position: absolute;
                        top: 0.625rem;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="softwareBeingUsedCopy"
                        required
                        name="softwareBeingUsedField"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  <div>
                    <div style="display: inline-block; margin-top: 1.5rem; margin-left: 1.5rem">
                      <mat-form-field
                        class="itFields"
                        style="width: 19.4rem; padding-left: 0.5rem; padding-right: 0.5rem"
                      >
                        <input
                          [(ngModel)]="vendorNameCopy"
                          placeholder="Vendor Name (Optional)"
                          matInput
                          name="vendorNameField"
                        />
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.5rem; margin-left: 1.5rem">
                      <mat-form-field
                        class="itFields"
                        style="width: 19.4rem; padding-left: 0.5rem; padding-right: 0.5rem"
                      >
                        <input
                          [(ngModel)]="softwareNameCopy"
                          placeholder="Software Name (Optional)"
                          matInput
                          name="softwareNameField"
                        />
                      </mat-form-field>
                    </div>
                    @if (softwareBeingUsedCopy !== 'NO') {
                      <div style="display: inline-block; margin-top: 1.5rem; margin-left: 1.5rem">
                        <mat-form-field
                          class="itFields"
                          style="width: 19.4rem; padding-left: 0.5rem; padding-right: 0.5rem"
                        >
                          <input
                            matInput
                            readonly
                            [(ngModel)]="inServiceYearCopy"
                            placeholder="In what year did it go in service?"
                            required
                            name="inServiceYearField"
                          />
                          <input
                            matInput
                            [matDatepicker]="dp"
                            [max]="currentDate"
                            [value]="getInServiceDate()"
                            class="service-year-dummy-input"
                          />
                          <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                          <mat-datepicker
                            #dp
                            startView="multi-year"
                            (yearSelected)="onInServiceYearSelection($event, dp)"
                          >
                          </mat-datepicker>
                        </mat-form-field>
                      </div>
                    }
                  </div>
                  <div style="margin-top: 1.5rem; margin-left: 1.5rem">
                    <span
                      class="bodyText"
                      [style.color]="
                        projectSetupForm.controls['softwareProjectOverviewField']?.touched &&
                        projectSetupForm.controls['softwareProjectOverviewField']?.errors?.required
                          ? '#9e1b32'
                          : ''
                      "
                      >Describe the software development work needed for this effort:</span
                    >
                  </div>
                  <div style="margin-top: 0.688rem; margin-left: 1.5rem">
                    <textarea
                      [(ngModel)]="softwareProjectOverviewCopy"
                      class="softwareProjectOverviewTextBox"
                      style="height: 4rem; width: 45.375rem; border-color: #26bcd7"
                      maxlength="255"
                      required
                      name="softwareProjectOverviewField"
                    ></textarea>
                  </div>
                  <div>
                    <span
                      style="
                        color: #696969;
                        font-style: italic;
                        float: right;
                        position: absolute;
                        right: 42.813rem;
                      "
                      >{{ softwareProjectLength() }} / 255 characters</span
                    >
                  </div>
                  <div style="width: 50.938rem">
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 1.5rem;
                        width: 37.688rem;
                      "
                    >
                      <span
                        class="bodyText"
                        [style.color]="
                          projectSetupForm.controls['dataConversionActivitiesField']?.touched &&
                          projectSetupForm.controls['dataConversionActivitiesField']?.errors
                            ?.required
                            ? '#9e1b32'
                            : ''
                        "
                        >Will you have data conversion activities? (If yes, the cost of running
                        processes or manually cleaning up data should be included in O&M estimate;
                        only development of data conversion software can be capitalized)</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        vertical-align: top;
                        float: right;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="dataConversionActivitiesCopy"
                        required
                        name="dataConversionActivitiesField"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  <div style="width: 50.938rem">
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 1.5rem;
                        width: 37.688rem;
                      "
                    >
                      <span
                        class="bodyText"
                        [style.color]="
                          projectSetupForm.controls['trainingCostsField']?.touched &&
                          projectSetupForm.controls['trainingCostsField']?.errors?.required
                            ? '#9e1b32'
                            : ''
                        "
                        >Will you have training costs? (If yes, the cost of train-the-trainer and
                        user training should be included in O&M estimate; only developer training on
                        how to develop the software can be capitalized)</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        vertical-align: top;
                        float: right;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="trainingCostsCopy"
                        required
                        name="trainingCostsField"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  <div style="width: 50.938rem">
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 1.5rem;
                        width: 37.688rem;
                      "
                    >
                      <span
                        class="bodyText"
                        [style.color]="
                          projectSetupForm.controls['associatedRetirementField']?.touched &&
                          projectSetupForm.controls['associatedRetirementField']?.errors?.required
                            ? '#9e1b32'
                            : ''
                        "
                        >Is there an associated retirement of existing software?</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        vertical-align: top;
                        float: right;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="associatedRetirementCopy"
                        required
                        name="associatedRetirementField"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  @if (associatedRetirementCopy === 'YES') {
                    <div style="display: inline-block">
                      <div style="display: inline-block; margin-top: 0.688rem; margin-left: 1.5rem">
                        <mat-form-field
                          class="itFields"
                          style="width: 19.4rem; padding-left: 0.5rem; padding-right: 0.5rem"
                        >
                          <input
                            [(ngModel)]="softwareToBeRetiredCopy"
                            placeholder="Software To Be Retired"
                            matInput
                            required
                            name="softwareToBeRetiredField"
                          />
                        </mat-form-field>
                      </div>
                      <div style="display: inline-block; margin-top: 0.688rem; margin-left: 1.5rem">
                        <mat-form-field
                          class="itFields"
                          style="width: 19.4rem; padding-left: 0.5rem; padding-right: 0.5rem"
                        >
                          <input
                            [(ngModel)]="retiredInServiceDateCopy"
                            placeholder="When was it in service?"
                            matInput
                            name="retiredInServiceDateField"
                          />
                        </mat-form-field>
                      </div>
                    </div>
                  }
                  <div style="width: 50.938rem">
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 1.5rem;
                        width: 37.688rem;
                      "
                    >
                      <span
                        class="bodyText"
                        [style.color]="
                          projectSetupForm.controls['maintenanceContractsField']?.touched &&
                          projectSetupForm.controls['maintenanceContractsField']?.errors?.required
                            ? '#9e1b32'
                            : ''
                        "
                        >Will you have any maintenance contracts/agreements?</span
                      >
                    </div>
                    <div
                      [class.moveDown]="associatedRetirementCopy === 'YES'"
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        vertical-align: top;
                        float: right;
                        position: relative;
                        top: -3.313rem;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="maintenanceContractsCopy"
                        required
                        name="maintenanceContractsField"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  <div style="width: 50.938rem">
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 1.5rem;
                        width: 37.688rem;
                      "
                    >
                      <span
                        class="bodyText"
                        [style.color]="
                          projectSetupForm.controls['replacingInterfacesField']?.touched &&
                          projectSetupForm.controls['replacingInterfacesField']?.errors?.required
                            ? '#9e1b32'
                            : ''
                        "
                        >Are you replacing any existing interfaces?</span
                      >
                    </div>
                    <div
                      [class.moveLeft]="associatedRetirementCopy === 'YES'"
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        vertical-align: top;
                        float: right;
                        position: relative;
                        top: -3.313rem;
                        left: 7.48rem;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="replacingInterfacesCopy"
                        required
                        name="replacingInterfacesField"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  <div>
                    <mat-form-field
                      class="itFields"
                      style="
                        margin-top: 1.5rem;
                        margin-left: 1.5rem;
                        margin-bottom: 1.5rem;
                        width: 30.938rem;
                        padding-left: 0.5rem;
                        padding-right: 0.5rem;
                      "
                    >
                      <mat-select
                        [(ngModel)]="howSoftwareReleasedCopy"
                        placeholder="How will the software be released?"
                        required
                        name="howSoftwareReleasedsField"
                      >
                        @for (option of howSoftwareReleasedOptions; track option) {
                          <mat-option style="color: #696969" [value]="option"
                            ><span>{{ option }}</span></mat-option
                          >
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  @if (isVendorHosted()) {
                    <div style="width: 50.938rem">
                      <div style="display: inline-block; margin-left: 1.5rem; width: 37.688rem">
                        <span
                          class="bodyText"
                          [style.color]="
                            projectSetupForm.controls['perpetualLicensesField']?.touched &&
                            projectSetupForm.controls['perpetualLicensesField']?.errors?.required
                              ? '#9e1b32'
                              : ''
                          "
                          >Will Duke own perpetual licenses?</span
                        >
                      </div>
                      <div
                        style="
                          display: inline-block;
                          vertical-align: top;
                          float: right;
                          position: relative;
                        "
                      >
                        <mat-radio-group
                          [(ngModel)]="perpetualLicensesCopy"
                          required
                          name="perpetualLicensesField"
                        >
                          <mat-radio-button color="primary" [value]="'YES'">
                            <span class="choiceText">YES</span>
                          </mat-radio-button>
                          <mat-radio-button
                            color="primary"
                            [value]="'NO'"
                            style="margin-left: 1.125rem"
                          >
                            <span class="choiceText">NO</span>
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  }
                  @if (isVendorHosted()) {
                    <div style="width: 50.938rem">
                      <div
                        style="
                          display: inline-block;
                          margin-top: 1.5rem;
                          margin-left: 1.5rem;
                          width: 36.688rem;
                        "
                      >
                        <span
                          class="bodyText"
                          [style.color]="
                            projectSetupForm.controls['contractualRightField']?.touched &&
                            projectSetupForm.controls['contractualRightField']?.errors?.required
                              ? '#9e1b32'
                              : ''
                          "
                          >Does Duke have the contractual right to take possession of the software
                          at any time during the arrangement period?</span
                        >
                      </div>
                      <div
                        style="
                          display: inline-block;
                          margin-top: 1.5rem;
                          vertical-align: top;
                          float: right;
                          position: relative;
                          top: -3.313rem;
                        "
                      >
                        <mat-radio-group
                          [(ngModel)]="contractualRightCopy"
                          required
                          name="contractualRightField"
                        >
                          <mat-radio-button color="primary" [value]="'YES'">
                            <span class="choiceText">YES</span>
                          </mat-radio-button>
                          <mat-radio-button
                            color="primary"
                            [value]="'NO'"
                            style="margin-left: 1.125rem"
                          >
                            <span class="choiceText">NO</span>
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  }
                  @if (isVendorHosted()) {
                    <div style="width: 50.938rem">
                      <div
                        style="
                          display: inline-block;
                          margin-top: 1.5rem;
                          margin-left: 1.5rem;
                          width: 37.688rem;
                        "
                      >
                        <span
                          class="bodyText"
                          [style.color]="
                            projectSetupForm.controls['significantPenaltytField']?.touched &&
                            projectSetupForm.controls['significantPenaltytField']?.errors?.required
                              ? '#9e1b32'
                              : ''
                          "
                          >Is there a significant penalty to take possession of the software and
                          bring it in house? (Significant penalty is interpreted as either a
                          significant cost or significant reduction in value or functionality when
                          taking possession of the software. Significant cost is defined as greater
                          than 15% of the total capital cost of the project)</span
                        >
                      </div>
                      <div
                        style="
                          display: inline-block;
                          margin-top: 1.5rem;
                          vertical-align: top;
                          float: right;
                          position: relative;
                          top: -6.313rem;
                        "
                      >
                        <mat-radio-group
                          [(ngModel)]="significantPenaltyCopy"
                          required
                          name="significantPenaltytField"
                        >
                          <mat-radio-button color="primary" [value]="'YES'">
                            <span class="choiceText">YES</span>
                          </mat-radio-button>
                          <mat-radio-button
                            color="primary"
                            [value]="'NO'"
                            style="margin-left: 1.125rem"
                          >
                            <span class="choiceText">NO</span>
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  }
                  @if (isVendorHosted()) {
                    <div style="width: 50.938rem">
                      <div
                        style="
                          display: inline-block;
                          margin-top: 1.5rem;
                          margin-left: 1.5rem;
                          width: 34.688rem;
                        "
                      >
                        <span
                          class="bodyText"
                          [style.color]="
                            projectSetupForm.controls['isFeasibleField']?.touched &&
                            projectSetupForm.controls['isFeasibleField']?.errors?.required
                              ? '#9e1b32'
                              : ''
                          "
                          >Is it feasible for Duke to run the software on our own hardware or to
                          contract with another third party host?</span
                        >
                      </div>
                      <div
                        style="
                          display: inline-block;
                          margin-top: 0.5rem;
                          vertical-align: top;
                          float: right;
                          position: relative;
                          top: -3.313rem;
                        "
                      >
                        <mat-radio-group
                          [(ngModel)]="isFeasibleCopy"
                          required
                          name="isFeasibleField"
                        >
                          <mat-radio-button color="primary" [value]="'YES'">
                            <span class="choiceText">YES</span>
                          </mat-radio-button>
                          <mat-radio-button
                            color="primary"
                            [value]="'NO'"
                            style="margin-left: 1.125rem"
                          >
                            <span class="choiceText">NO</span>
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  }
                  @if (isVendorHosted()) {
                    <div style="width: 50.938rem">
                      <div
                        style="
                          display: inline-block;
                          margin-top: 1.5rem;
                          margin-left: 1.5rem;
                          width: 37.688rem;
                        "
                      >
                        <span
                          class="bodyText"
                          [style.color]="
                            projectSetupForm.controls['serviceFeesField']?.touched &&
                            projectSetupForm.controls['serviceFeesField']?.errors?.required
                              ? '#9e1b32'
                              : ''
                          "
                          >Are there service or usage fees?</span
                        >
                      </div>
                      <div
                        style="
                          display: inline-block;
                          margin-top: 1.5rem;
                          vertical-align: top;
                          float: right;
                          position: relative;
                          top: -3.313rem;
                        "
                      >
                        <mat-radio-group
                          [(ngModel)]="serviceFeesCopy"
                          required
                          name="serviceFeesField"
                        >
                          <mat-radio-button color="primary" [value]="'YES'">
                            <span class="choiceText">YES</span>
                          </mat-radio-button>
                          <mat-radio-button
                            color="primary"
                            [value]="'NO'"
                            style="margin-left: 1.125rem"
                          >
                            <span class="choiceText">NO</span>
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  }
                  @if (isVendorHosted()) {
                    <div style="width: 50.938rem">
                      <div
                        style="
                          display: inline-block;
                          margin-top: 1.5rem;
                          margin-left: 1.5rem;
                          margin-bottom: 1.5rem;
                          width: 37.688rem;
                        "
                      >
                        <span
                          class="bodyText"
                          [style.color]="
                            projectSetupForm.controls['useWithoutPayingField']?.touched &&
                            projectSetupForm.controls['useWithoutPayingField']?.errors?.required
                              ? '#9e1b32'
                              : ''
                          "
                          >If we stop paying the service or usage fees, can we still use the
                          software?</span
                        >
                      </div>
                      <div
                        style="
                          display: inline-block;
                          vertical-align: top;
                          float: right;
                          position: relative;
                          top: -3.313rem;
                        "
                      >
                        <mat-radio-group
                          [(ngModel)]="useWithoutPayingCopy"
                          required
                          name="useWithoutPayingField"
                        >
                          <mat-radio-button color="primary" [value]="'YES'">
                            <span class="choiceText">YES</span>
                          </mat-radio-button>
                          <mat-radio-button
                            color="primary"
                            [value]="'NO'"
                            style="margin-left: 1.125rem"
                          >
                            <span class="choiceText">NO</span>
                          </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </form>
      <div style="margin-top: 2.625rem">
        <span class="itProjectHeader" style="font-size: 1.313rem">Page Two</span>
      </div>
      <form #projectEstimateForm="ngForm" (keydown.enter)="$event.preventDefault()">
        <div style="display: inline-block; margin-top: 1.5rem">
          @if (!editFormMode) {
            <div style="width: 23.438rem; height: 6.25rem">
              <div style="display: inline-block; margin-top: 1.125rem">
                <mat-form-field class="itFields" style="width: 19.4rem">
                  <input
                    readonly="true"
                    type="text"
                    placeholder="Who will this work benefit?"
                    matInput
                    [(ngModel)]="department.department"
                    name="department"
                  />
                </mat-form-field>
              </div>
            </div>
          }
          @if (editFormMode) {
            <div style="width: 23.438rem; height: 6.25rem; background-color: #f3fafd">
              <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                <mat-form-field
                  class="itFields"
                  style="width: 19.4rem; padding-left: 0.5rem; padding-right: 0.5rem"
                >
                  <mat-select
                    [(ngModel)]="departmentCopy"
                    placeholder="Who will this work benefit?"
                    (selectionChange)="
                      deleteDefaultOption(); assignAllocationDefaults($event.value)
                    "
                    required
                    name="departmentCopy"
                    [compareWith]="compareDepartment"
                  >
                    @for (option of defaultsByDepartment; track option) {
                      <mat-option style="color: #696969" [value]="option"
                        ><span>{{ option.department }}</span></mat-option
                      >
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          }
        </div>
        <div style="display: inline-block; margin-top: 1.5rem">
          @if (!editFormMode) {
            <div style="width: 38.438rem; height: 6.25rem">
              <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                <mat-form-field class="itFields" style="width: 34.563rem">
                  <input
                    readonly="true"
                    type="text"
                    placeholder="Building Info (Building Name)"
                    matInput
                    [(ngModel)]="buildingInfo.BuildingName"
                    name="buildingInfo"
                  />
                </mat-form-field>
              </div>
            </div>
          }
          @if (editFormMode) {
            <div style="width: 38.438rem; height: 6.25rem; background-color: #f3fafd">
              <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                @if (!(buildingInfoCopy && buildingInfoCopy.BuildingName)) {
                  <mat-form-field
                    class="itFields"
                    style="width: 34.563rem; padding-left: 0.5rem; padding-right: 0.5rem"
                  >
                    <input
                      type="text"
                      placeholder="Building Info (Building Name)"
                      matAutocompletePosition="below"
                      matInput
                      [matAutocomplete]="auto1"
                      [formControl]="buildingInfoControl"
                      [(ngModel)]="buildingInfoCopy"
                      required
                      name="buildingInfoField"
                    />
                  </mat-form-field>
                }
                @if (buildingInfoCopy && buildingInfoCopy.BuildingName) {
                  <mat-form-field
                    class="itFields"
                    style="width: 34.563rem; padding-left: 0.5rem; padding-right: 0.5rem"
                  >
                    <input
                      type="text"
                      placeholder="Building Info (Building Name)"
                      matAutocompletePosition="below"
                      matInput
                      [matAutocomplete]="auto1"
                      [formControl]="buildingInfoControl"
                      [(ngModel)]="buildingInfoCopy"
                      readonly="true"
                    />
                  </mat-form-field>
                }
                <mat-autocomplete
                  #auto1="matAutocomplete"
                  [displayWith]="displayFnBuildingInfo"
                  (optionSelected)="assignBuilding($event.option.value)"
                >
                  @for (option of filteredBuildingInfoOptions | async; track option) {
                    <mat-option style="color: #696969" [value]="option"
                      ><span>{{ option.BuildingName }}</span></mat-option
                    >
                  }
                </mat-autocomplete>
                @if (buildingInfoCopy && buildingInfoCopy.BuildingName) {
                  <div
                    style="
                      display: inline-block;
                      padding-top: 0.8rem;
                      z-index: 0;
                      position: absolute;
                    "
                  >
                    <img
                      (click)="deleteBuildingInfo()"
                      style="margin-left: -1.5rem; cursor: pointer"
                      src="assets/close-window.svg"
                    />
                  </div>
                }
              </div>
            </div>
          }
        </div>
        @if (
          !(hardwareOrSoftwareCopy === 'Hardware Only' || hardwareOrSoftwareCopy === 'O&M Only')
        ) {
          <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
            <span class="projectScopeHeader">Release Details</span>
          </div>
        }
        @if (
          !(hardwareOrSoftwareCopy === 'Hardware Only' || hardwareOrSoftwareCopy === 'O&M Only')
        ) {
          <div style="padding-top: 1.5rem; width: 78rem">
            <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
              <span class="projectScopeHeader">Capability and Release Details</span>
            </div>
            <div style="height: 0.1rem; background-color: #f5f5f5"></div>
          </div>
        }
        <div>
          @if (
            !editFormMode &&
            !(hardwareOrSoftwareCopy === 'Hardware Only' || hardwareOrSoftwareCopy === 'O&M Only')
          ) {
            <div>
              @for (releaseDetail of releaseDetails; track releaseDetail; let i = $index) {
                <div>
                  @for (
                    capabilityDetail of releaseDetail.capabilityDetails;
                    track capabilityDetail;
                    let j = $index;
                    let jindex = $index
                  ) {
                    <div>
                      <div style="width: 78rem; height: 6.25rem">
                        <div
                          style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem"
                        >
                          <mat-form-field class="itFields" style="width: 6rem">
                            <input
                              readonly="true"
                              [(ngModel)]="capabilityDetail.releaseNumber"
                              placeholder="Release #"
                              matInput
                              name="'releaseNumber' + i + jindex"
                            />
                          </mat-form-field>
                        </div>
                        <div
                          style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem"
                        >
                          <mat-form-field
                            style="
                              background: white;
                              padding-left: 0.4rem;
                              padding-right: 0.4rem;
                              margin-top: 1.125rem;
                              width: 7.1rem;
                              height: 4rem;
                            "
                          >
                            <mat-label>Release Date</mat-label>
                            <input
                              readonly="true"
                              matInput
                              [matDatepicker]="dp"
                              [(ngModel)]="capabilityDetail.releaseDate"
                              style="color: #696969"
                              name="releaseDate"
                            />
                            <mat-datepicker #dp></mat-datepicker>
                          </mat-form-field>
                        </div>
                        <div
                          style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem"
                        >
                          <mat-form-field
                            class="itFields"
                            style="width: 19.138rem; cursor: pointer"
                            (click)="openCapabilityDialog(i, jindex, true)"
                          >
                            <input
                              readonly="true"
                              style="pointer-events: none"
                              [(ngModel)]="capabilityDetail.capabilities"
                              placeholder="Capability"
                              matInput
                              name="'capabilities' + i + jindex"
                            />
                          </mat-form-field>
                        </div>
                        <div
                          style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem"
                        >
                          <mat-form-field
                            class="itFields"
                            style="width: 19.138rem; cursor: pointer"
                            (click)="openCapabilityDialog(i, jindex, true)"
                          >
                            <input
                              readonly="true"
                              style="pointer-events: none"
                              [(ngModel)]="capabilityDetail.description"
                              placeholder="Detailed Description of Capability"
                              matInput
                              name="'description' + i + jindex"
                            />
                          </mat-form-field>
                        </div>
                        <div
                          style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem"
                        >
                          <mat-form-field
                            class="itFields"
                            style="width: 6rem"
                            [floatLabel]="'always'"
                          >
                            <input
                              readonly="true"
                              type="text"
                              [ngModel]="
                                +capabilityDetail.capitalCost | CurrencyUSD: 'USD' : true : false
                              "
                              placeholder="Capital Cost"
                              matInput
                              [name]="'capabilityDetail.capitalCost' + i + jindex"
                            />
                          </mat-form-field>
                        </div>
                        <div
                          style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem"
                        >
                          <mat-form-field
                            class="itFields"
                            style="width: 6rem"
                            [floatLabel]="'always'"
                          >
                            <input
                              readonly="true"
                              type="text"
                              [ngModel]="
                                +capabilityDetail.omCost | CurrencyUSD: 'USD' : true : false
                              "
                              placeholder="O&M Cost"
                              matInput
                              [name]="'capabilityDetail' + i + jindex"
                            />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              <div style="height: 0.1rem; background-color: #f5f5f5; width: 78rem"></div>
            </div>
          }
          @if (
            editFormMode &&
            !(hardwareOrSoftwareCopy === 'Hardware Only' || hardwareOrSoftwareCopy === 'O&M Only')
          ) {
            <div>
              @for (releaseDetail of releaseDetailsCopy; track releaseDetail; let i = $index) {
                <div>
                  @for (
                    capabilityDetail of releaseDetail.capabilityDetails;
                    track capabilityDetail;
                    let j = $index;
                    let jindex = $index
                  ) {
                    <div>
                      <div
                        style="width: 78rem; height: 6.25rem"
                        [class.backgroundColorBlue]="!isOdd(i)"
                        [class.backgroundColorGray]="isOdd(i)"
                      >
                        <div
                          style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem"
                        >
                          @if (jindex !== 0) {
                            <mat-form-field
                              class="itFields"
                              [class.backgroundBlue]="!isOdd(i)"
                              [class.backgroundGray]="isOdd(i)"
                              style="width: 6rem; padding-left: 0.5rem; padding-right: 0.5rem"
                            >
                              <input
                                [(ngModel)]="capabilityDetail.releaseNumber"
                                placeholder="Release #"
                                matInput
                                readonly="true"
                                (change)="releaseNumberChange(i, jindex)"
                                required
                                [name]="
                                  'releaseDetail.capabilityDetail.releaseNumberField' + i + jindex
                                "
                              />
                            </mat-form-field>
                          }
                          @if (jindex === 0) {
                            <mat-form-field
                              class="itFields"
                              style="width: 6rem; padding-left: 0.5rem; padding-right: 0.5rem"
                            >
                              <input
                                [(ngModel)]="capabilityDetail.releaseNumber"
                                placeholder="Release #"
                                matInput
                                (change)="releaseNumberChange(i, jindex)"
                                required
                                [name]="
                                  'releaseDetail.capabilityDetail.releaseNumberField' + i + jindex
                                "
                              />
                            </mat-form-field>
                          }
                        </div>
                        <div
                          style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem"
                        >
                          @if (jindex !== 0) {
                            <mat-form-field
                              [class.backgroundBlue]="!isOdd(i)"
                              [class.backgroundGray]="isOdd(i)"
                              style="
                                background: white;
                                padding-left: 0.4rem;
                                padding-right: 0.4rem;
                                margin-top: 1.125rem;
                                width: 7.1rem;
                                height: 4rem;
                                pointer-events: none;
                              "
                            >
                              <mat-label>Release Date</mat-label>
                              <input
                                matInput
                                [matDatepicker]="j"
                                [(ngModel)]="capabilityDetail.releaseDate"
                                style="color: #696969"
                                [min]="estimatedStartDateCopy"
                                [max]="estimatedInServiceDateCopy"
                                readonly="true"
                                (dateChange)="releaseDateChange(i, jindex)"
                                required
                                [name]="
                                  'releaseDetail.capabilityDetail.releaseDateField' + i + jindex
                                "
                              />
                              <mat-datepicker-toggle matSuffix [for]="j"></mat-datepicker-toggle>
                              <mat-datepicker #j></mat-datepicker>
                            </mat-form-field>
                          }
                          @if (jindex === 0) {
                            <mat-form-field
                              style="
                                background: white;
                                padding-left: 0.4rem;
                                padding-right: 0.4rem;
                                margin-top: 1.125rem;
                                width: 7.1rem;
                                height: 4rem;
                              "
                            >
                              <mat-label>Release Date</mat-label>
                              <input
                                matInput
                                [matDatepicker]="j"
                                [(ngModel)]="capabilityDetail.releaseDate"
                                style="color: #696969"
                                [min]="estimatedStartDateCopy"
                                [max]="estimatedInServiceDateCopy"
                                (dateChange)="releaseDateChange(i, jindex)"
                                required
                                [name]="
                                  'releaseDetail.capabilityDetail.releaseDateField' + i + jindex
                                "
                              />
                              <mat-datepicker-toggle matSuffix [for]="j"></mat-datepicker-toggle>
                              <mat-datepicker #j></mat-datepicker>
                            </mat-form-field>
                          }
                        </div>
                        <div
                          style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem"
                        >
                          <mat-form-field
                            class="itFields"
                            style="
                              width: 19.138rem;
                              cursor: pointer;
                              padding-left: 0.5rem;
                              padding-right: 0.5rem;
                            "
                            (click)="openCapabilityDialog(i, jindex, false)"
                          >
                            <input
                              readonly="true"
                              style="pointer-events: none"
                              [(ngModel)]="capabilityDetail.capabilities"
                              placeholder="Capability"
                              matInput
                              required
                              [name]="'releaseDetail.capabilityDetail.capabilityField' + i + jindex"
                            />
                          </mat-form-field>
                        </div>
                        <div
                          style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem"
                        >
                          <mat-form-field
                            class="itFields"
                            style="
                              width: 19.138rem;
                              cursor: pointer;
                              padding-left: 0.5rem;
                              padding-right: 0.5rem;
                            "
                            (click)="openCapabilityDialog(i, jindex, false)"
                          >
                            <input
                              readonly="true"
                              style="pointer-events: none"
                              [(ngModel)]="capabilityDetail.description"
                              placeholder="Detailed Description of Capability"
                              matInput
                              [name]="
                                'releaseDetail.capabilityDetail.descriptionField' + i + jindex
                              "
                            />
                          </mat-form-field>
                        </div>
                        <div
                          style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem"
                        >
                          <mat-form-field
                            class="itFields"
                            style="width: 6rem; padding-left: 0.5rem; padding-right: 0.5rem"
                            [floatLabel]="'always'"
                          >
                            <input
                              appCurrencyMask
                              appNumbersOnly
                              [allowDecimals]="true"
                              onkeypress="return event.charCode != 45;"
                              [(ngModel)]="capabilityDetail.capitalCost"
                              placeholder="Capital Cost"
                              matInput
                              [name]="
                                'releaseDetail.capabilityDetail.capitalCostField' + i + jindex
                              "
                            />
                            <span matPrefix>$</span>
                          </mat-form-field>
                        </div>
                        <div
                          style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem"
                        >
                          <mat-form-field
                            class="itFields"
                            style="width: 6rem; padding-left: 0.5rem; padding-right: 0.5rem"
                            [floatLabel]="'always'"
                          >
                            <input
                              appCurrencyMask
                              appNumbersOnly
                              [allowDecimals]="true"
                              onkeypress="return event.charCode != 45;"
                              [(ngModel)]="capabilityDetail.omCost"
                              placeholder="O&M Cost"
                              matInput
                              [name]="'releaseDetail.capabilityDetail.OMCostField' + i + jindex"
                            />
                            <span matPrefix>$</span>
                          </mat-form-field>
                        </div>
                        <div
                          style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem"
                        >
                          <img
                            style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 2.5rem"
                            src="assets/trash-bin-base.svg"
                            (click)="deleteRelease(i, jindex)"
                          />
                        </div>
                      </div>
                    </div>
                  }
                  <div>
                    <div
                      style="width: 78rem"
                      [class.backgroundColorBlue]="!isOdd(i)"
                      [class.backgroundColorGray]="isOdd(i)"
                    >
                      <div
                        style="
                          padding-left: 2rem;
                          padding-top: 1.563rem;
                          padding-bottom: 1.313rem;
                          cursor: pointer;
                          width: 15rem;
                        "
                        (click)="addCapability(i)"
                      >
                        <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
                        <span
                          style="
                            padding-left: 0.2rem;
                            text-decoration: underline;
                            text-underline-offset: 0.2rem;
                          "
                          >Add a Capability to this Release</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div style="height: 0.1rem; background-color: #f5f5f5; width: 78rem"></div>
              <div style="width: 78rem; background-color: #f3fafd">
                <div
                  style="
                    padding-left: 1rem;
                    padding-top: 1.188rem;
                    padding-bottom: 1.313rem;
                    cursor: pointer;
                    width: 15rem;
                  "
                  (click)="addRelease()"
                >
                  <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
                  <span
                    style="
                      padding-left: 0.2rem;
                      text-decoration: underline;
                      text-underline-offset: 0.2rem;
                    "
                    >Add Another Release</span
                  >
                </div>
              </div>
            </div>
          }
          <div style="display: inline-block; margin-top: 1.5rem">
            <div style="width: 23.438rem; height: 6.25rem">
              <div style="display: flex; margin-top: 1.125rem; gap: 40px; width: 50rem">
                @if (editFormMode) {
                  <mat-form-field class="itFields" style="width: 22.4rem">
                    <mat-select
                      [(ngModel)]="distributeCostCopy"
                      placeholder="How do you want to distribute cost across business?"
                      (selectionChange)="distributeCostChange($event.value)"
                      required
                      name="distributeCostCopy"
                    >
                      @for (option of distributeOptions; track option) {
                        <mat-option style="color: #696969" [value]="option"
                          ><span>{{ option }}</span></mat-option
                        >
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (!editFormMode) {
                  <mat-form-field class="itFields" style="width: 22.4rem">
                    <input
                      readonly="true"
                      type="text"
                      placeholder="How do you want to distribute cost across business?"
                      matInput
                      [(ngModel)]="distributeCostCopy"
                      name="distributeCostCopy"
                    />
                  </mat-form-field>
                }
                @if (
                  editFormMode &&
                  !(
                    distributeCostCopy !== 'Default' ||
                    !(departmentCopy && departmentCopy.department)
                  )
                ) {
                  <mat-form-field class="itFields" style="width: 19.4rem">
                    <mat-select
                      [(ngModel)]="defaultOptionCopy"
                      placeholder="Please select one of the default options:"
                      (selectionChange)="
                        setDefaultAllocation($event.value); setAllocationsAsTouched()
                      "
                      required
                      name="defaultOptionCopy"
                    >
                      @for (option of allocationDefaultsCopy; track option) {
                        <mat-option style="color: #696969" [value]="option"
                          ><span>{{ option }}</span></mat-option
                        >
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (!editFormMode && defaultOptionCopy) {
                  <mat-form-field class="itFields" style="width: 19.4rem">
                    <input
                      readonly="true"
                      type="text"
                      placeholder="Please select one of the default options:"
                      matInput
                      [(ngModel)]="defaultOptionCopy"
                      name="defaultOptionCopy"
                    />
                  </mat-form-field>
                }
              </div>
            </div>
          </div>
          <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
            <span class="projectScopeHeader">Allocations</span>
          </div>
          @if (!editFormMode) {
            <div>
              @for (allocation of allocations; track allocation; let i = $index) {
                <div>
                  <div
                    style="height: 6.25rem"
                    [ngStyle]="{
                      width: isAllocationFunctionVisible(allocations) ? '90rem' : '78rem',
                    }"
                  >
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                      <mat-form-field class="itFields" style="width: 21.563rem">
                        <input
                          readonly="true"
                          type="text"
                          placeholder="Operating Unit"
                          matInput
                          [(ngModel)]="allocation.displayOperatingUnit"
                          [name]="'allocationOperatingUnit' + i"
                        />
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
                      <mat-form-field class="itFields" style="width: 21.563rem">
                        <input
                          readonly="true"
                          [(ngModel)]="allocation.businessUnit"
                          placeholder="Business Unit"
                          matInput
                          [name]="'allocationBusinessUnit' + i"
                        />
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
                      <mat-form-field class="itFields" style="width: 9.563rem">
                        <input
                          readonly="true"
                          type="text"
                          placeholder="Funding Project ID"
                          matInput
                          [(ngModel)]="allocation.fundingProjectID.work_order_number"
                          [name]="'allocationFundingProjectID' + i"
                        />
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
                      <mat-form-field
                        [class.hiddenElement]="stateDisabled(allocation)"
                        class="itFields"
                        style="width: 6.563rem"
                      >
                        <input
                          readonly="true"
                          type="text"
                          placeholder="State"
                          matInput
                          [(ngModel)]="allocation.state"
                          [name]="'allocationState' + i"
                        />
                      </mat-form-field>
                    </div>
                    <div
                      [class.removeElement]="
                        !isAllocationFunctionVisible(allocations) && !showFunctionField(allocation)
                      "
                      [class.hiddenElement]="!allocation.function"
                      style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem"
                    >
                      <mat-form-field class="itFields" style="width: 6.563rem">
                        <input
                          readonly="true"
                          type="text"
                          placeholder="Function"
                          matInput
                          [(ngModel)]="allocation.function"
                          [name]="'allocationFunction' + i"
                        />
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
                      <mat-form-field class="itFields" style="width: 7rem">
                        <input
                          readonly="true"
                          type="text"
                          [ngModel]="allocation.percentage / 100 | percent: '1.0-2'"
                          placeholder="Percentage"
                          [name]="'allocationPercentage' + i"
                          matInput
                          (animationstart)="allocationTotal()"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                  <div
                    style="height: 0.1rem; background-color: #f5f5f5"
                    [ngStyle]="{
                      width: isAllocationFunctionVisible(allocations) ? '90rem' : '78rem',
                    }"
                  ></div>
                </div>
              }
            </div>
          }
          @if (editFormMode) {
            <div>
              @for (allocation of allocationsCopy; track allocation; let i = $index) {
                <div>
                  <div
                    style="height: 6.25rem; background-color: #f3fafd"
                    [ngStyle]="{
                      width: isAllocationFunctionVisible(allocationsCopy) ? '90rem' : '78rem',
                    }"
                  >
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                      <mat-form-field
                        class="itFields"
                        style="width: 21.563rem; background-color: #f3fafd"
                      >
                        <input
                          type="text"
                          placeholder="Operating Unit"
                          matAutocompletePosition="below"
                          matInput
                          [matAutocomplete]="auto2"
                          [formControl]="operatingUnitControl[i]"
                          [(ngModel)]="allocation.operatingUnit"
                          required
                        />
                      </mat-form-field>
                      <mat-autocomplete
                        #auto2="matAutocomplete"
                        [displayWith]="displayFnOperatingUnit"
                        (optionSelected)="
                          setBusinessUnit(allocation, $event.option.value, i);
                          getFundingProjectIDChoices(allocation, $event.option.value, i);
                          getUOPDescriptionChoices();
                          setAllocationsAsTouched();
                          updateMatchingBusinessUnits(i)
                        "
                      >
                        @for (option of filteredOperatingUnitOptions[i] | async; track option) {
                          <mat-option style="color: #696969" [value]="option"
                            ><span
                              >{{ option.OPERATING_UNIT }} - {{ option.DESCR }}</span
                            ></mat-option
                          >
                        }
                      </mat-autocomplete>
                      @if (allocation.operatingUnit && allocation.operatingUnit.OPERATING_UNIT) {
                        <div
                          style="
                            display: inline-block;
                            padding-top: 0.8rem;
                            z-index: 0;
                            position: absolute;
                          "
                        >
                          <img
                            (click)="deleteOperatingUnit(i)"
                            style="margin-left: -1.5rem; cursor: pointer"
                            src="assets/close-window.svg"
                          />
                        </div>
                      }
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
                      <mat-form-field
                        class="itFields"
                        style="width: 21.563rem; background-color: #f3fafd"
                      >
                        <input
                          [(ngModel)]="allocation.businessUnit"
                          placeholder="Business Unit"
                          matInput
                          readonly="true"
                          [name]="'allocationBusinessUnitEdit' + i"
                        />
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
                      @if (fundingProjectIDDisabled(allocation, i)) {
                        <mat-form-field
                          [class.removeElement]="allocation.hasFundingError"
                          class="itFields"
                          style="
                            width: 9.563rem;
                            background-color: #f3fafd;
                            padding-left: 0.5rem;
                            padding-right: 0.5rem;
                          "
                        >
                          <input
                            type="text"
                            placeholder="Funding Project ID"
                            matAutocompletePosition="below"
                            matInput
                            [matAutocomplete]="auto6"
                            [formControl]="fundingProjectControl[i]"
                            [(ngModel)]="allocation.fundingProjectID"
                            required
                            [name]="'allocation.fundingProjectIDField' + i"
                          />
                        </mat-form-field>
                      }
                      @if (
                        allocation.fundingProjectID && allocation.fundingProjectID.work_order_number
                      ) {
                        <mat-form-field
                          [class.removeElement]="
                            fundingProjectIDDisabled(allocation, i) || allocation.hasFundingError
                          "
                          class="itFields"
                          style="width: 9.563rem; padding-left: 0.5rem; padding-right: 0.5rem"
                        >
                          <input
                            type="text"
                            placeholder="Funding Project ID"
                            matAutocompletePosition="below"
                            matInput
                            [matAutocomplete]="auto6"
                            [formControl]="fundingProjectControl[i]"
                            [(ngModel)]="allocation.fundingProjectID"
                            required
                            [name]="'allocation.fundingProjectIDField' + i"
                          />
                        </mat-form-field>
                      }
                      @if (
                        !(
                          allocation.fundingProjectID &&
                          allocation.fundingProjectID.work_order_number
                        )
                      ) {
                        <mat-form-field
                          [class.removeElement]="
                            fundingProjectIDDisabled(allocation, i) || allocation.hasFundingError
                          "
                          class="itFields"
                          style="width: 9.563rem; padding-left: 0.5rem; padding-right: 0.5rem"
                        >
                          <input
                            type="text"
                            placeholder="Funding Project ID"
                            matAutocompletePosition="below"
                            matInput
                            [matAutocomplete]="auto6"
                            [formControl]="fundingProjectControl[i]"
                            [(ngModel)]="allocation.fundingProjectID"
                            required
                            [name]="'allocation.fundingProjectIDField' + i"
                          />
                        </mat-form-field>
                      }
                      <mat-autocomplete
                        [class.removeElement]="
                          fundingProjectIDDisabled(allocation, i) || allocation.hasFundingError
                        "
                        #auto6="matAutocomplete"
                        [displayWith]="displayFnFundingProject"
                        (optionSelected)="updateMatchingBusinessUnits(i)"
                      >
                        @for (option of filteredFundingProjectOptions[i] | async; track option) {
                          <mat-option style="color: #696969" [value]="option">
                            <span>{{ option.work_order_number }}</span>
                          </mat-option>
                        }
                      </mat-autocomplete>
                      @if (
                        allocation.fundingProjectID && allocation.fundingProjectID.work_order_number
                      ) {
                        <div
                          [class.removeElement]="
                            fundingProjectIDDisabled(allocation, i) || allocation.hasFundingError
                          "
                          style="
                            display: inline-block;
                            padding-top: 0.8rem;
                            z-index: 0;
                            position: absolute;
                          "
                        >
                          <img
                            (click)="deleteFundingProjectID(i)"
                            style="margin-left: -1.5rem; cursor: pointer"
                            src="assets/close-window.svg"
                          />
                        </div>
                      }
                      @if (allocation.hasFundingError) {
                        <div style="padding-left: 0.5rem; padding-right: 0.5rem; width: 9.563rem">
                          <span style="color: #9e1b32; font-size: 0.875rem"
                            >Projects can not be set up for this business unit</span
                          >
                        </div>
                      }
                    </div>
                    <div
                      [class.hiddenElement]="stateDisabled(allocation)"
                      [ngStyle]="{
                        display:
                          isRepeatedOperatingUnit(i) && !stateDisabled(allocation)
                            ? 'none'
                            : 'inline-block',
                      }"
                      style="margin-top: 1.125rem; margin-left: 0.683rem"
                    >
                      <mat-form-field
                        class="itFields"
                        style="width: 6.563rem; padding-left: 0.5rem; padding-right: 0.5rem"
                      >
                        <mat-select
                          [(ngModel)]="allocation.state"
                          placeholder="State"
                          [required]="!stateDisabled(allocation)"
                          [name]="'allocationStateEdit' + i"
                          (selectionChange)="updateMatchingBusinessUnits(i)"
                        >
                          @for (option of allocation.stateOptions; track option) {
                            <mat-option style="color: #696969" [value]="option">
                              <span>{{ option }}</span>
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div
                      [class.removeElement]="
                        !isAllocationFunctionVisible(allocationsCopy) &&
                        !showFunctionField(allocation)
                      "
                      [class.hiddenElement]="
                        isAllocationFunctionVisible(allocationsCopy) &&
                        !showFunctionField(allocation)
                      "
                      [ngStyle]="{
                        display:
                          !isAllocationFunctionVisible(allocationsCopy) &&
                          !showFunctionField(allocation)
                            ? 'none'
                            : 'inline-block',
                      }"
                      style="margin-top: 1.125rem; margin-left: 0.683rem"
                    >
                      <mat-form-field class="itFields" style="width: 6.563rem">
                        <mat-select
                          [(ngModel)]="allocation.function"
                          placeholder="Function"
                          [required]="showFunctionField(allocation)"
                          [name]="'allocationFunctionEdit' + i"
                        >
                          @for (option of getAllocationFunctions(allocation); track option) {
                            <mat-option style="color: #696969" [value]="option"
                              ><span>{{ option }}</span></mat-option
                            >
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.683rem">
                      <mat-form-field
                        class="itFields"
                        style="width: 7rem; padding-left: 0.5rem; padding-right: 0.5rem"
                      >
                        <input
                          type="number"
                          [min]="0"
                          [max]="100"
                          [step]="0.01"
                          onkeypress="return event.charCode != 45;"
                          [(ngModel)]="allocation.percentage"
                          (animationstart)="allocationTotal()"
                          (ngModelChange)="allocationTotal()"
                          placeholder="Percentage"
                          matInput
                          required
                          [name]="'allocationPercentage' + i"
                        />
                        <span matSuffix>%</span>
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
                      <img
                        style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 1rem"
                        src="assets/trash-bin-base.svg"
                        (click)="deleteAllocation(i)"
                      />
                    </div>
                  </div>
                  <div
                    style="height: 0.1rem; background-color: #f5f5f5"
                    [ngStyle]="{
                      width: isAllocationFunctionVisible(allocationsCopy) ? '90rem' : '78rem',
                    }"
                  ></div>
                </div>
              }
              <div
                style="background-color: #f3fafd"
                [ngStyle]="{
                  width: isAllocationFunctionVisible(allocationsCopy) ? '90rem' : '78rem',
                }"
              >
                <div
                  style="
                    padding-left: 1rem;
                    padding-top: 1.188rem;
                    padding-bottom: 1.313rem;
                    cursor: pointer;
                    width: 15rem;
                  "
                  (click)="addNewAllocation()"
                >
                  <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
                  <span
                    style="
                      padding-left: 0.2rem;
                      text-decoration: underline;
                      text-underline-offset: 0.2rem;
                    "
                    >Add New Unit Line</span
                  >
                </div>
                <div
                  style="position: relative; float: right; margin-top: -4rem; margin-right: 3.6rem"
                >
                  <div>
                    <span style="color: #696969">Total Allocation:</span>
                  </div>
                  <div>
                    <span style="color: #696969; font-weight: bold"
                      >{{ allocationTotalValue }}%</span
                    >
                  </div>
                </div>
                <div
                  [class.removeElement]="!emptyAllocationLine()"
                  style="
                    text-align: right;
                    padding-right: 0.688rem;
                    padding-bottom: 0.625rem;
                    color: darkred;
                  "
                >
                  <span
                    >Allocation % for an Operating Unit cannot be zero. Please add a percentage
                    value or delete the line.</span
                  >
                </div>
                <div
                  [class.removeElement]="!multipleNuclearHardwareSoftware()"
                  style="
                    text-align: right;
                    padding-right: 0.688rem;
                    padding-bottom: 0.625rem;
                    color: darkred;
                  "
                >
                  <span
                    >Cannot enter Hardware and Software on a single form when allocating across
                    Nuclear Stations. Please change the form to either be Hardware or Software, and
                    then enter an additional form for the other one.
                  </span>
                </div>
                <div
                  [class.removeElement]="allocationTotalValue == 100"
                  style="
                    text-align: right;
                    padding-right: 0.688rem;
                    padding-bottom: 0.625rem;
                    color: darkred;
                  "
                >
                  <span>Total Allocation must equal 100% in order to proceed</span>
                </div>
                <div
                  [class.removeElement]="
                    emptyAllocationLine() ||
                    duplicateAllocation() ||
                    multipleNuclearHardwareSoftware() ||
                    sameNuclearSite() ||
                    !(allocationTotalValue == 100)
                  "
                  style="
                    text-align: right;
                    padding-right: 0.688rem;
                    padding-bottom: 0.625rem;
                    color: darkred;
                  "
                >
                  <span></span>
                </div>
              </div>
            </div>
          }
          <div style="width: 78rem">
            <div
              [class.hiddenElement]="true"
              style="
                padding-left: 1rem;
                padding-top: 1.188rem;
                padding-bottom: 1.313rem;
                cursor: pointer;
                width: 15rem;
              "
            >
              <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
              <span
                style="
                  padding-left: 0.2rem;
                  text-decoration: underline;
                  text-underline-offset: 0.2rem;
                "
                >Add New Unit Line</span
              >
            </div>
            @if (!editFormMode) {
              <div
                style="position: relative; float: right; margin-top: -4rem; margin-right: 7.6rem"
              >
                <div>
                  <span style="color: #696969">Total Allocation:</span>
                </div>
                <div>
                  <span style="color: #696969; font-weight: bold">{{ allocationTotalValue }}%</span>
                </div>
              </div>
            }
            @if (!editFormMode && emptyAllocationLine()) {
              <div
                style="
                  text-align: right;
                  padding-right: 0.688rem;
                  padding-bottom: 0.625rem;
                  color: darkred;
                "
              >
                <span
                  >Allocation % for an Operating Unit cannot be zero. Please add a percentage
                  value.</span
                >
              </div>
            }
            @if (!editFormMode && allocationTotalValue !== 100) {
              <div
                style="
                  text-align: right;
                  padding-right: 0.688rem;
                  padding-bottom: 0.625rem;
                  color: darkred;
                "
              >
                <span>Total Allocation must equal 100% in order to proceed</span>
              </div>
            }
          </div>
          <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
            <span class="projectScopeHeader">Estimate Details</span>
          </div>
          <div style="padding-top: 1.5rem; width: 78rem">
            <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
              <span class="projectScopeHeader">Material Details</span>
            </div>
            <div style="height: 0.1rem; background-color: #f5f5f5"></div>
          </div>
          @if (!editFormMode) {
            <div>
              @for (building of buildings; track building; let i = $index) {
                <div>
                  <div style="width: 78rem">
                    <div style="padding-left: 1.5rem; padding-top: 1.156rem">
                      <span class="projectScopeSubHeader">Building</span>
                    </div>
                    <div style="display: inline-block; margin-top: 0.625rem; margin-left: 1.5rem">
                      <mat-form-field class="itFields" style="width: 36.75rem">
                        <input
                          readonly="true"
                          type="text"
                          placeholder="Building Name"
                          matInput
                          [(ngModel)]="building.buildingName.BuildingName"
                          [name]="'buildingName' + i"
                        />
                      </mat-form-field>
                    </div>
                    @if (building.materialEstimates && building.materialEstimates.length > 0) {
                      <div>
                        @if (building.buildingName) {
                          <div style="padding-left: 1.5rem; padding-top: 1.156rem">
                            <span class="projectScopeSubHeader"
                              >Materials for {{ building.buildingName.BuildingName }}</span
                            >
                          </div>
                        }
                        @if (!building.buildingName) {
                          <div style="padding-left: 1.5rem; padding-top: 1.156rem">
                            <span class="projectScopeSubHeader">Materials for </span>
                          </div>
                        }
                        @for (
                          estimate of building.materialEstimates;
                          track estimate;
                          let j = $index
                        ) {
                          <div>
                            <div
                              style="
                                display: inline-block;
                                margin-top: 1.125rem;
                                margin-left: 1.5rem;
                              "
                            >
                              <mat-form-field class="itFields" style="width: 5.625rem">
                                <input
                                  readonly="true"
                                  type="text"
                                  placeholder="Cost"
                                  matInput
                                  [(ngModel)]="estimate.cost"
                                  [name]="'estimateCost' + i + j"
                                />
                              </mat-form-field>
                            </div>
                            <div
                              style="
                                display: inline-block;
                                margin-top: 1.125rem;
                                margin-left: 0.438rem;
                              "
                            >
                              <mat-form-field class="itFields" style="width: 18rem">
                                <input
                                  readonly="true"
                                  [(ngModel)]="estimate.unitOfPropertyDetails"
                                  placeholder="Details"
                                  matInput
                                  [name]="'unitOfPropertyDetails' + i + j"
                                />
                              </mat-form-field>
                            </div>
                            <div
                              style="
                                display: inline-block;
                                margin-top: 1.125rem;
                                margin-left: 0.438rem;
                              "
                            >
                              <mat-form-field
                                class="itFields"
                                style="width: 24.313rem"
                                [class.hiddenElement]="estimate.cost === 'O&M'"
                              >
                                <input
                                  readonly="true"
                                  type="text"
                                  placeholder="Unit of Property Description"
                                  matInput
                                  [(ngModel)]="estimate.unitOfPropertyDescription"
                                  [name]="'unitOfPropertyDescription' + i + j"
                                />
                              </mat-form-field>
                            </div>
                            <div
                              style="
                                display: inline-block;
                                margin-top: 1.125rem;
                                margin-left: 0.438rem;
                              "
                            >
                              <mat-form-field class="itFields" style="width: 5.625rem">
                                <input
                                  readonly="true"
                                  type="text"
                                  appCurrencyMask
                                  [value]="estimate.quantity"
                                  placeholder="Quantity"
                                  matInput
                                />
                              </mat-form-field>
                            </div>
                            <div
                              style="
                                display: inline-block;
                                margin-top: 1.125rem;
                                margin-left: 0.438rem;
                              "
                            >
                              <mat-form-field
                                class="itFields"
                                style="width: 6rem"
                                [floatLabel]="'always'"
                              >
                                <input
                                  readonly="true"
                                  type="text"
                                  [value]="+estimate.unitCosts | CurrencyUSD: 'USD' : true : false"
                                  placeholder="Unit Costs"
                                  matInput
                                />
                              </mat-form-field>
                            </div>
                            <div
                              style="
                                display: inline-block;
                                margin-top: 1.125rem;
                                margin-left: 0.438rem;
                              "
                            >
                              <mat-form-field
                                class="itFields"
                                style="width: 6rem"
                                [floatLabel]="'always'"
                              >
                                <input
                                  readonly="true"
                                  type="text"
                                  [value]="+estimate.totalCosts | CurrencyUSD: 'USD' : true : false"
                                  placeholder="Total Costs"
                                  matInput
                                />
                              </mat-form-field>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <div style="height: 0.1rem; background-color: #f5f5f5; width: 78rem"></div>
                  </div>
                </div>
              }
            </div>
          }
          @if (editFormMode) {
            <div>
              @for (building of buildingsCopy; track building; let i = $index) {
                <div>
                  <div
                    style="width: 78rem"
                    [class.backgroundColorBlue]="!isOdd(i)"
                    [class.backgroundColorGray]="isOdd(i)"
                  >
                    <div style="padding-left: 1.5rem; padding-top: 1.156rem">
                      <span class="projectScopeSubHeader">Building</span>
                    </div>
                    @if (!isExtraBuilding(building.buildingName)) {
                      <div style="display: inline-block; margin-top: 0.625rem; margin-left: 1.5rem">
                        <mat-form-field
                          class="itFields"
                          style="width: 36.75rem; padding-left: 0.5rem; padding-right: 0.5rem"
                        >
                          <input
                            type="text"
                            placeholder="Building Name"
                            matAutocompletePosition="below"
                            matInput
                            [matAutocomplete]="auto2"
                            [formControl]="buildingControl[i]"
                            [(ngModel)]="building.buildingName"
                            required
                            [name]="'building.buildingNameField' + i"
                          />
                        </mat-form-field>
                        <mat-autocomplete
                          #auto2="matAutocomplete"
                          [displayWith]="displayFnBuildingInfo"
                        >
                          @for (option of filteredBuildingOptions[i] | async; track option) {
                            <mat-option style="color: #696969" [value]="option"
                              ><span>{{ option.BuildingName }}</span></mat-option
                            >
                          }
                        </mat-autocomplete>
                        @if (
                          building && building.buildingName && building.buildingName.BuildingName
                        ) {
                          <div
                            style="
                              display: inline-block;
                              padding-top: 0.8rem;
                              z-index: 0;
                              position: absolute;
                            "
                          >
                            <img
                              (click)="deleteBuildingName(i)"
                              style="margin-left: -1.5rem; cursor: pointer"
                              src="assets/close-window.svg"
                            />
                          </div>
                        }
                      </div>
                    }
                    @if (isExtraBuilding(building.buildingName)) {
                      <div style="display: inline-block; margin-top: 0.625rem; margin-left: 1.5rem">
                        <mat-form-field
                          class="itFields"
                          style="
                            width: 36.75rem;
                            background-color: #f3fafd;
                            padding-left: 0.5rem;
                            padding-right: 0.5rem;
                          "
                        >
                          <input
                            type="text"
                            placeholder="Building Name"
                            matInput
                            [(ngModel)]="building.buildingName.BuildingName"
                            readonly="true"
                            required
                            [name]="'building.buildingName.BuildingNameField' + i"
                          />
                        </mat-form-field>
                      </div>
                    }
                    @if (!isExtraBuilding(building.buildingName)) {
                      <div
                        style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem"
                      >
                        <img
                          style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 1rem"
                          src="assets/trash-bin-base.svg"
                          (click)="deleteBuilding(i)"
                        />
                      </div>
                    }
                    @if (!isExtraBuilding(building.buildingName)) {
                      <div style="display: inline-block">
                        <span class="projectScopeText"
                          >Note: Deleting the building will delete all Material entries associated
                          with it</span
                        >
                      </div>
                    }
                    @if (building.materialEstimates && building.materialEstimates.length > 0) {
                      <div>
                        @if (building.buildingName) {
                          <div style="padding-left: 1.5rem; padding-top: 1.156rem">
                            <span class="projectScopeSubHeader"
                              >Materials for {{ building.buildingName.BuildingName }}</span
                            >
                          </div>
                        }
                        @if (!building.buildingName) {
                          <div style="padding-left: 1.5rem; padding-top: 1.156rem">
                            <span class="projectScopeSubHeader">Materials for </span>
                          </div>
                        }
                        @for (
                          estimate of building.materialEstimates;
                          track estimate;
                          let j = $index
                        ) {
                          <div
                            [class.adjustForWarning]="
                              j !== 0 && tangiblePropertyCheck(building.materialEstimates[j - 1])
                            "
                          >
                            <div
                              [class.errorBorder]="tangiblePropertyCheck(estimate)"
                              style="
                                display: inline-block;
                                margin-top: 1.125rem;
                                margin-left: 1.5rem;
                              "
                            >
                              <mat-form-field
                                class="itFields"
                                style="width: 5.625rem; padding-left: 0.5rem; padding-right: 0.5rem"
                              >
                                <mat-select
                                  [(ngModel)]="estimate.cost"
                                  placeholder="Cost"
                                  (selectionChange)="costChanged($event.value, i, j)"
                                  [name]="'estimate.cost' + i + j"
                                  [required]="isMaterialRequired() || !materialsFilledOut()"
                                >
                                  @for (option of costOptions; track option) {
                                    <mat-option style="color: #696969" [value]="option"
                                      ><span>{{ option }}</span></mat-option
                                    >
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div
                              style="
                                display: inline-block;
                                margin-top: 1.125rem;
                                margin-left: 0.438rem;
                              "
                            >
                              <mat-form-field
                                class="itFields"
                                style="width: 18rem; padding-left: 0.5rem; padding-right: 0.5rem"
                              >
                                <input
                                  [(ngModel)]="estimate.unitOfPropertyDetails"
                                  placeholder="Details"
                                  matInput
                                  [name]="'estimate.unitOfPropertyDetailsField' + i + j"
                                  [required]="isMaterialRequired() || !materialsFilledOut()"
                                />
                              </mat-form-field>
                            </div>
                            <div
                              style="
                                display: inline-block;
                                margin-top: 1.125rem;
                                margin-left: 0.438rem;
                              "
                              [ngStyle]="{
                                width: estimate.cost !== 'O&M' ? 'auto' : '25.35rem',
                              }"
                            >
                              @if (estimate.cost !== 'O&M') {
                                <mat-form-field
                                  class="itFields"
                                  style="
                                    width: 24.313rem;
                                    padding-left: 0.5rem;
                                    padding-right: 0.5rem;
                                  "
                                >
                                  <mat-select
                                    [(ngModel)]="estimate.unitOfPropertyDescription"
                                    placeholder="Unit of Property Description"
                                    [name]="'estimate.unitOfPropertyDescription' + i + j"
                                    [required]="isMaterialRequired() || !materialsFilledOut()"
                                  >
                                    @for (option of uopOptions; track option) {
                                      <mat-option style="color: #696969" [value]="option"
                                        ><span>{{ option }}</span></mat-option
                                      >
                                    }
                                  </mat-select>
                                </mat-form-field>
                              }
                            </div>
                            <div
                              style="
                                display: inline-block;
                                margin-top: 1.125rem;
                                margin-left: 0.438rem;
                              "
                            >
                              <mat-form-field
                                class="itFields"
                                style="width: 5.625rem; padding-left: 0.5rem; padding-right: 0.5rem"
                              >
                                <input
                                  type="number"
                                  [min]="0"
                                  onkeypress="return event.charCode != 45;"
                                  [(ngModel)]="estimate.quantity"
                                  placeholder="Quantity"
                                  matInput
                                  (keyup)="recalculateTotalCost(i, j)"
                                  [name]="'estimate.quantityField' + i + j"
                                  [required]="isMaterialRequired() || !materialsFilledOut()"
                                />
                              </mat-form-field>
                            </div>
                            <div
                              [class.errorBorder]="
                                tangiblePropertyCheck(estimate) ||
                                (!tangibleTotalCostCheck(estimate) && tangibleDateCheck(estimate))
                              "
                              style="
                                display: inline-block;
                                margin-top: 1.125rem;
                                margin-left: 0.438rem;
                              "
                            >
                              <mat-form-field
                                class="itFields"
                                style="width: 6rem; padding-left: 0.5rem; padding-right: 0.5rem"
                                [floatLabel]="'always'"
                              >
                                <input
                                  appCurrencyMask
                                  appNumbersOnly
                                  [allowDecimals]="true"
                                  onkeypress="return event.charCode != 45;"
                                  [(ngModel)]="estimate.unitCosts"
                                  placeholder="Unit Costs"
                                  matInput
                                  (keyup)="recalculateTotalCost(i, j)"
                                  [name]="'estimate.unitCostsField' + i + j"
                                  [required]="isMaterialRequired() || !materialsFilledOut()"
                                />
                                <span matPrefix>$</span>
                              </mat-form-field>
                            </div>
                            <div
                              [class.errorBorder]="tangibleTotalCostCheck(estimate)"
                              style="
                                display: inline-block;
                                margin-top: 1.125rem;
                                margin-left: 0.438rem;
                              "
                            >
                              <mat-form-field
                                class="itFields"
                                style="
                                  width: 6rem;
                                  background-color: #f3fafd;
                                  padding-left: 0.5rem;
                                  padding-right: 0.5rem;
                                "
                                [floatLabel]="'always'"
                              >
                                <input
                                  readonly="true"
                                  [value]="estimate.totalCosts | CurrencyUSD: 'USD' : true : false"
                                  placeholder="Total Costs"
                                  matInput
                                  [required]="isMaterialRequired() || !materialsFilledOut()"
                                  [name]="'estimate.totalCostsField' + i + j"
                                />
                              </mat-form-field>
                            </div>
                            <div
                              style="
                                display: inline-block;
                                margin-top: 1.125rem;
                                margin-right: 0.5rem;
                              "
                            >
                              <img
                                style="
                                  cursor: pointer;
                                  width: 1rem;
                                  height: 1rem;
                                  padding-left: 1rem;
                                "
                                src="assets/trash-bin-base.svg"
                                (click)="deleteEstimate(i, j)"
                              />
                            </div>
                            @if (tangiblePropertyCheck(estimate)) {
                              <div
                                style="
                                  position: absolute;
                                  width: 38rem;
                                  left: 41.938rem;
                                  padding-top: 0.625rem;
                                "
                              >
                                <span style="color: #9e1b32; font-size: 0.875rem"
                                  >Tangible (non-software) units of property must have a unit cost
                                  of at least $500 to qualify as capital</span
                                >
                              </div>
                            }
                            @if (tangibleTotalCostCheck(estimate)) {
                              <div
                                style="
                                  position: absolute;
                                  width: 57rem;
                                  left: 22.8rem;
                                  padding-top: 0.625rem;
                                "
                              >
                                <span style="color: #9e1b32; font-size: 0.875rem"
                                  >If tangible (non-software) units of property have a unit cost
                                  between $500 and $999, then the total cost must be at least
                                  $50,000 to qualify as capital</span
                                >
                              </div>
                            }
                            @if (!tangibleTotalCostCheck(estimate) && tangibleDateCheck(estimate)) {
                              <div
                                style="
                                  position: absolute;
                                  width: 62rem;
                                  left: 17.8rem;
                                  padding-top: 0.625rem;
                                "
                              >
                                <span style="color: #9e1b32; font-size: 0.875rem"
                                  >If tangible (non-software) units of property have a unit cost
                                  between $500 and $999, the work must be scheduled to be done
                                  within 12 months to qualify as capital</span
                                >
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                    <div
                      style="width: 78rem"
                      [class.backgroundColorBlue]="!isOdd(i)"
                      [class.backgroundColorGray]="isOdd(i)"
                    >
                      <div
                        style="
                          padding-left: 2rem;
                          padding-top: 1.188rem;
                          padding-bottom: 1.313rem;
                          cursor: pointer;
                          width: 15rem;
                        "
                        (click)="addMaterial(i)"
                      >
                        <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
                        <span
                          style="
                            padding-left: 0.2rem;
                            text-decoration: underline;
                            text-underline-offset: 0.2rem;
                          "
                          >Add New Material</span
                        >
                      </div>
                    </div>
                    <div style="height: 0.1rem; background-color: #f5f5f5; width: 78rem"></div>
                  </div>
                </div>
              }
              <div style="width: 78rem; background-color: #f3fafd">
                <div
                  [class.noClick]="isExtraBuilding(buildings[0].buildingName)"
                  style="
                    padding-left: 1rem;
                    padding-top: 1.188rem;
                    padding-bottom: 1.313rem;
                    cursor: pointer;
                    width: 15rem;
                  "
                  (click)="addBuilding()"
                >
                  <span
                    [class.hiddenElement]="isExtraBuilding(buildings[0].buildingName)"
                    style="font-weight: bold; font-size: 1.4rem"
                    >&#43;</span
                  >
                  <span
                    [class.hiddenElement]="isExtraBuilding(buildings[0].buildingName)"
                    style="
                      padding-left: 0.2rem;
                      text-decoration: underline;
                      text-underline-offset: 0.2rem;
                    "
                    >Add Another Building</span
                  >
                </div>
              </div>
            </div>
          }
          <div style="width: 78rem; background-color: #f3fafd">
            @if (!editFormMode) {
              <div
                style="position: relative; float: right; margin-top: 1.5rem; margin-right: 7.3rem"
              >
                <div>
                  <span style="color: #696969">Total Estimated:</span>
                </div>
                <div>
                  <span style="color: #696969; font-weight: bold"
                    >${{ buildingTotal().toLocaleString('en', { useGrouping: true }) }}</span
                  >
                </div>
              </div>
            }
            @if (editFormMode) {
              <div style="position: relative; float: right; margin-top: 1.5rem; margin-right: 2rem">
                <div>
                  <span style="color: #696969">Total Estimated:</span>
                </div>
                <div>
                  <span style="color: #696969; font-weight: bold"
                    >${{ buildingTotal().toLocaleString('en', { useGrouping: true }) }}</span
                  >
                </div>
              </div>
            }
          </div>
          <div
            style="display: inline-block; padding-top: 1.5rem; width: 78rem; margin-top: 0.688rem"
          >
            <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
              <span class="projectScopeHeader">Employee/Contractor Labor Details</span>
            </div>
            <div style="height: 0.1rem; background-color: #f5f5f5"></div>
          </div>
          @if (!editFormMode) {
            <div style="width: 78rem; height: 6.25rem; display: inline-block">
              @for (detail of laborDetails; track detail; let i = $index) {
                <div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                    <mat-form-field class="itFields" style="width: 12rem">
                      <input
                        readonly="true"
                        type="text"
                        placeholder="Work Task"
                        matInput
                        [value]="detail.workTask ? detail.workTask.workTask : ''"
                      />
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                    <mat-form-field class="itFields" style="width: 39.875rem">
                      <input
                        readonly="true"
                        type="text"
                        placeholder="Work Description"
                        matInput
                        [(ngModel)]="detail.workDescription"
                        [name]="'workDescription' + i"
                      />
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                    <mat-form-field class="itFields" style="width: 9rem">
                      <input
                        readonly="true"
                        type="text"
                        placeholder="Charge Type"
                        matInput
                        [(ngModel)]="detail.chargeType"
                        [name]="'chargeType' + i"
                      />
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
                    <mat-form-field class="itFields" style="width: 6rem" [floatLabel]="'always'">
                      <input
                        readonly="true"
                        type="text"
                        [ngModel]="+detail.totalCosts | CurrencyUSD: 'USD' : true : false"
                        placeholder="Total Costs"
                        matInput
                        [name]="'totalCosts' + i"
                      />
                    </mat-form-field>
                  </div>
                </div>
              }
              <div style="width: 78rem; background-color: #f3fafd">
                <div style="position: relative; float: right; margin-right: 7rem">
                  <div>
                    <span style="color: #696969">Total Estimated:</span>
                  </div>
                  <div>
                    <span style="color: #696969; font-weight: bold"
                      >${{ laborTotal().toLocaleString('en', { useGrouping: true }) }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          }
          @if (editFormMode) {
            <div
              style="
                width: 78rem;
                height: 6.25rem;
                background-color: #f3fafd;
                display: inline-block;
              "
            >
              @for (detail of laborDetailsCopy; track detail; let i = $index) {
                <div style="background-color: #f3fafd">
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                    <mat-form-field
                      class="itFields"
                      style="width: 12rem; padding-left: 0.5rem; padding-right: 0.5rem"
                    >
                      <mat-select
                        [(ngModel)]="detail.workTask"
                        placeholder="Work Task"
                        (selectionChange)="workTaskChanged($event.value, i)"
                        [compareWith]="compareWorkTask"
                        [required]="isEmployeeContractorRequired()"
                        [name]="'laborDetail.workTaskField' + i"
                      >
                        @for (option of workTaskOptions; track option) {
                          <mat-option style="color: #696969" [value]="option"
                            ><span>{{ option.workTask }}</span></mat-option
                          >
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                    @if (workDescriptions[i] && workDescriptions[i].length === 0) {
                      <mat-form-field
                        class="itFields"
                        style="
                          width: 39.875rem;
                          background-color: #f3fafd;
                          padding-left: 0.5rem;
                          padding-right: 0.5rem;
                        "
                      >
                        <input
                          type="text"
                          placeholder="Work Description"
                          matInput
                          [(ngModel)]="detail.workDescription"
                          readonly="true"
                          [name]="'laborDetail.workDescriptionField' + i"
                          [required]="isEmployeeContractorRequired()"
                        />
                      </mat-form-field>
                    }
                    <mat-form-field
                      [class.removeElement]="
                        workDescriptions[i] && workDescriptions[i].length === 0
                      "
                      class="itFields"
                      style="width: 39.875rem; padding-left: 0.5rem; padding-right: 0.5rem"
                    >
                      <mat-select
                        [(ngModel)]="detail.workDescription"
                        placeholder="Work Description"
                        [required]="isEmployeeContractorRequired()"
                        [name]="'laborDetail.workDescriptionField' + i"
                      >
                        @for (option of workDescriptions[i]; track option) {
                          <mat-option style="color: #696969" [value]="option"
                            ><span>{{ option }}</span></mat-option
                          >
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                    <mat-form-field
                      class="itFields"
                      style="width: 9rem; padding-left: 0.5rem; padding-right: 0.5rem"
                    >
                      <mat-select
                        [(ngModel)]="detail.chargeType"
                        placeholder="Charge Type"
                        [name]="'laborDetail.chargeTypeField' + i"
                        [required]="isEmployeeContractorRequired()"
                      >
                        @for (option of chargeTypeOptions; track option) {
                          <mat-option style="color: #696969" [value]="option"
                            ><span>{{ option }}</span></mat-option
                          >
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
                    <mat-form-field
                      class="itFields"
                      style="width: 6rem; padding-left: 0.5rem; padding-right: 0.5rem"
                      [floatLabel]="'always'"
                    >
                      <input
                        appCurrencyMask
                        appNumbersOnly
                        [allowDecimals]="true"
                        onkeypress="return event.charCode != 45;"
                        [(ngModel)]="detail.totalCosts"
                        placeholder="Total Costs"
                        matInput
                        [name]="'laborDetail.totalCostsField' + i"
                        [required]="isEmployeeContractorRequired()"
                      />
                      <span matPrefix>$</span>
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
                    <img
                      style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 1rem"
                      src="assets/trash-bin-base.svg"
                      (click)="deleteLaborDetail(i)"
                    />
                  </div>
                </div>
              }
              <div style="width: 78rem; background-color: #f3fafd">
                <div
                  style="
                    padding-left: 1rem;
                    padding-top: 1.188rem;
                    padding-bottom: 1.313rem;
                    cursor: pointer;
                    width: 15rem;
                  "
                  (click)="addLaborDetail()"
                >
                  <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
                  <span
                    style="
                      padding-left: 0.2rem;
                      text-decoration: underline;
                      text-underline-offset: 0.2rem;
                    "
                    >Add New Labor</span
                  >
                </div>
                <div
                  style="position: relative; float: right; margin-top: -4rem; margin-right: 3.6rem"
                >
                  <div>
                    <span style="color: #696969">Total Estimated:</span>
                  </div>
                  <div>
                    <span style="color: #696969; font-weight: bold"
                      >${{ laborTotal().toLocaleString('en', { useGrouping: true }) }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
        <div style="padding-top: 1.5rem; width: 78rem; margin-top: 2.2rem; display: inline-block">
          <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
            <span class="projectScopeHeader">Contingency and Other Details (Optional)</span>
          </div>
          <div style="height: 0.1rem; background-color: #f5f5f5"></div>
        </div>
        @if (!editFormMode) {
          <div style="width: 78rem; height: 6.25rem; display: inline-block">
            @for (detail of contingencyDetails; track detail; let i = $index) {
              <div>
                <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                  <mat-form-field class="itFields" style="width: 15rem">
                    <input
                      readonly="true"
                      type="text"
                      placeholder="Cost"
                      matInput
                      [(ngModel)]="detail.cost"
                      [name]="'detailCost' + i"
                    />
                  </mat-form-field>
                </div>
                <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                  <mat-form-field class="itFields" style="width: 47.15rem">
                    <input
                      readonly="true"
                      [(ngModel)]="detail.description"
                      placeholder="Description"
                      matInput
                      [name]="'detailDescription' + i"
                    />
                  </mat-form-field>
                </div>
                <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
                  <mat-form-field class="itFields" style="width: 6rem" [floatLabel]="'always'">
                    <input
                      readonly="true"
                      type="text"
                      [value]="+detail.totalCosts | CurrencyUSD: 'USD' : true : false"
                      placeholder="Total Costs"
                      matInput
                    />
                  </mat-form-field>
                </div>
              </div>
            }
            <div style="width: 78rem; background-color: #f3fafd">
              <div style="position: relative; float: right; margin-right: 6rem">
                <div>
                  <span style="color: #696969">Total Estimated:</span>
                </div>
                <div>
                  <span style="color: #696969; font-weight: bold"
                    >${{ contingencyTotal().toLocaleString('en', { useGrouping: true }) }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        }
        @if (editFormMode) {
          <div
            style="width: 78rem; height: 6.25rem; background-color: #f3fafd; display: inline-block"
          >
            @for (detail of contingencyDetailsCopy; track detail; let i = $index) {
              <div style="background-color: #f3fafd">
                <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                  <mat-form-field
                    class="itFields"
                    style="width: 15rem; padding-left: 0.5rem; padding-right: 0.5rem"
                  >
                    <mat-select
                      [(ngModel)]="detail.cost"
                      placeholder="Cost"
                      [name]="'contingencyDetail.costField' + i"
                      [required]="isContingencyRowMissing(i, 'cost')"
                    >
                      @for (option of contingencyCostOptions; track option) {
                        <mat-option style="color: #696969" [value]="option"
                          ><span>{{ option }}</span></mat-option
                        >
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.5rem">
                  <mat-form-field
                    class="itFields"
                    style="width: 47.15rem; padding-left: 0.5rem; padding-right: 0.5rem"
                  >
                    <input
                      [(ngModel)]="detail.description"
                      placeholder="Description"
                      matInput
                      [name]="'contingencyDetail.descriptionField' + i"
                      [required]="isContingencyRowMissing(i, 'description')"
                    />
                  </mat-form-field>
                </div>
                <div style="display: inline-block; margin-top: 1.125rem; margin-left: 0.438rem">
                  <mat-form-field
                    class="itFields"
                    style="width: 6rem; padding-left: 0.5rem; padding-right: 0.5rem"
                    [floatLabel]="'always'"
                  >
                    <input
                      appCurrencyMask
                      appNumbersOnly
                      [allowDecimals]="true"
                      onkeypress="return event.charCode != 45;"
                      [(ngModel)]="detail.totalCosts"
                      placeholder="Total Costs"
                      matInput
                      [name]="'contingencyDetail.totalCostsField' + i"
                      [required]="isContingencyRowMissing(i, 'totalCosts')"
                    />
                    <span matPrefix>$</span>
                  </mat-form-field>
                </div>
                <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
                  <img
                    style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 1rem"
                    src="assets/trash-bin-base.svg"
                    (click)="deleteContingencyDetail(i)"
                  />
                </div>
              </div>
            }
            <div style="width: 78rem; background-color: #f3fafd">
              <div
                style="
                  padding-left: 1rem;
                  padding-top: 1.188rem;
                  padding-bottom: 1.313rem;
                  cursor: pointer;
                  width: 15rem;
                "
                (click)="addContingencyDetail()"
              >
                <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
                <span
                  style="
                    padding-left: 0.2rem;
                    text-decoration: underline;
                    text-underline-offset: 0.2rem;
                  "
                  >Add New Contingency/Other</span
                >
              </div>
              <div
                style="position: relative; float: right; margin-top: -4rem; margin-right: 3.6rem"
              >
                <div>
                  <span style="color: #696969">Total Estimated:</span>
                </div>
                <div>
                  <span style="color: #696969; font-weight: bold"
                    >${{ contingencyTotal().toLocaleString('en', { useGrouping: true }) }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        }
        <div
          style="
            padding-top: 1.5rem;
            width: 78rem;
            margin-top: 2.2rem;
            display: inline-block;
            padding-bottom: 1rem;
          "
        >
          <div style="width: 78rem; margin-bottom: 1.5rem; text-align: center">
            <div class="projectScopeHeader pb-1">Cost Summary</div>
            <div style="height: 0.1rem; background-color: #f5f5f5"></div>
          </div>
          <div class="cost-container mb-1 pb-1 grey-border-bottom">
            <div class="cost-column">Total Capital $ by Charge Type</div>
            <div class="cost-column"></div>
            <div class="cost-column">Total O&M $ by Charge Type</div>
            <div class="cost-column"></div>
            <div class="cost-column"></div>
            <div class="cost-column"></div>
          </div>
          <div class="cost-container">
            <div class="cost-column">Internal Labor</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ internalCapital().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
            <div class="cost-column">Internal Labor</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ internalOM().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
            <div class="cost-column">Capital Cost</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ subtotalCapital().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
          </div>
          <div class="cost-container">
            <div class="cost-column">External Labor</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ externalCapital().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
            <div class="cost-column">External Labor</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ externalOM().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
            <div class="cost-column">Estimated AFUDC of Project</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ estimatedAFUDC().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
          </div>
          <div class="cost-container">
            <div class="cost-column">Material</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ materialCapital().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
            <div class="cost-column">Material</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ materialOM().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
            <div class="cost-column">Total Capital Cost</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ totalCapitalCost().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
          </div>
          <div class="cost-container">
            <div class="cost-column">Contingency</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{
                    contingencyCapital().toLocaleString('en', {
                      useGrouping: true,
                    })
                  }}
                </div>
              </div>
            </div>
            <div class="cost-column">Contingency</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ contingencyOM().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
            <div class="cost-column"></div>
            <div class="cost-column"></div>
          </div>
          <div class="cost-container">
            <div class="cost-column">Other</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ otherCapital().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
            <div class="cost-column">Other</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ otherOM().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
            <div class="cost-column"></div>
            <div class="cost-column"></div>
          </div>
          <div class="cost-container">
            <div class="cost-column">Subtotal</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ subtotalCapital().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
            <div class="cost-column">Subtotal</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ subtotalOM().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
            <div class="cost-column">Total O&M Cost</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ subtotalOM().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
          </div>
          <div class="cost-container">
            <div class="cost-column">Subtotal This Request</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{
                    subtotalCapitalThisRequest().toLocaleString('en', {
                      useGrouping: true,
                    })
                  }}
                </div>
              </div>
            </div>
            <div class="cost-column">Subtotal This Request</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{
                    subtotalOMThisRequest().toLocaleString('en', {
                      useGrouping: true,
                    })
                  }}
                </div>
              </div>
            </div>
            <div class="cost-column">Total Cost (Including AFUDC)</div>
            <div class="cost-column">
              <div class="cost">
                <div>$</div>
                <div>
                  {{ totalProjectCost().toLocaleString('en', { useGrouping: true }) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
          <span class="projectScopeHeader">Additional Comments to ITPAC (Optional)</span>
        </div>
        <div style="margin-top: 0.688rem">
          @if (!editFormMode) {
            <div class="p-1 grey-border text-grey width-60">
              {{ additionalComments }}
            </div>
          }
          @if (editFormMode) {
            <textarea
              [(ngModel)]="additionalCommentsCopy"
              class="scopeDescriptionTextBox"
              style="border-color: rgb(38, 188, 215)"
              maxlength="255"
              name="additionalCommentsField"
            ></textarea>
          }
        </div>
        @if (editFormMode) {
          <div>
            <span style="color: #696969; font-style: italic; margin-right: 9.938rem; float: right"
              >{{ additionalCommentLength() }} / 255 characters</span
            >
          </div>
        }
        <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
          <span class="projectScopeHeader">Attachments</span>
        </div>
        <div style="margin-top: 0.5rem; margin-bottom: 0.5rem">
          <span class="projectScopeNonHeader"
            >Note: Files are for review purposes only. Files uploaded in MMAPS will
            <span style="font-style: italic; font-size: 0.9rem">not</span> be added to
            PowerPlan.</span
          >
        </div>
        @if (canEditForm() && editFormMode) {
          <ng-container>
            <input
              type="file"
              style="display: none"
              (change)="onFileSelected($event)"
              #fileUpload
              multiple
            />
            <div
              (drop)="onDrop($event)"
              (dragover)="onDragOver($event)"
              style="
                width: 49.125rem;
                height: 4.063rem;
                border: 0.063rem solid #ccc;
                border-radius: 0.875rem;
              "
            >
              <div style="text-align: center; margin-top: 1.125rem">
                <img
                  style="width: 1rem; height: 1rem; padding-left: 1rem"
                  src="assets/attach-file.svg"
                />
                <span style="color: rgb(105, 105, 105)">Drop a file here or </span>
                <span style="cursor: pointer" (click)="fileUpload.click()">browse to upload</span>
              </div>
            </div>
          </ng-container>
        }

        @if (filesCopy.length > 0) {
          <div
            style="
              background-color: #f3fafd;
              padding-top: 1.5rem;
              width: 48.375rem;
              margin-top: 1.5rem;
              display: inline-block;
              padding-bottom: 1rem;
            "
          >
            <div style="margin-top: 1.5rem; margin-left: 1.5rem">
              <div style="display: inline-block">
                <span class="projectScopeSubHeader" style="font-size: 0.875rem">File Name</span>
              </div>
              <div style="display: inline-block; margin-left: 15rem">
                <span class="projectScopeSubHeader" style="font-size: 0.875rem">Added By</span>
              </div>
              <div style="display: inline-block; margin-left: 10rem">
                <span class="projectScopeSubHeader" style="font-size: 0.875rem">Date</span>
              </div>
              <div
                style="
                  display: inline-block;
                  height: 0.1rem;
                  background-color: #f5f5f5;
                  margin-bottom: 0.5rem;
                  width: 46rem;
                "
              ></div>
              @for (file of filesCopy; track file; let i = $index) {
                <div>
                  <div style="display: inline-block; width: 19.05rem">
                    <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
                      file.fileName
                    }}</span>
                  </div>
                  <div style="display: inline-block; width: 13.95rem">
                    <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
                      file.addedByName
                    }}</span>
                  </div>
                  <div style="display: inline-block">
                    <span class="projectScopeNonHeader" style="font-size: 0.875rem">{{
                      file.date
                    }}</span>
                  </div>
                  <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
                    <img
                      style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 3.5rem"
                      src="assets/file-download.svg"
                      (click)="downloadFile(i)"
                    />
                  </div>
                  @if (canEditForm() && editFormMode) {
                    <div style="display: inline-block; margin-top: 1.125rem; margin-right: 0.5rem">
                      <img
                        style="cursor: pointer; width: 1rem; height: 1rem; padding-left: 1rem"
                        src="assets/trash-bin-base.svg"
                        (click)="deleteFile(i)"
                      />
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
        <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
          <span class="projectScopeHeader">Approvers</span>
        </div>
        <div style="padding-top: 1.5rem; width: 78rem; display: inline-block">
          <div style="margin-top: 1.5rem">
            <div style="display: inline-block; white-space: nowrap">
              <span class="projectScopeSubHeader" style="font-size: 0.875rem">Name, Title</span>
            </div>
            <div style="display: inline-block; margin-left: 60.438rem; white-space: nowrap">
              <span class="projectScopeSubHeader" style="font-size: 0.875rem"
                >DOA Authority Amount</span
              >
            </div>
          </div>
          <div
            style="
              display: inline-block;
              height: 0.1rem;
              background-color: #f5f5f5;
              margin-bottom: 0.5rem;
              width: 75.625rem;
            "
          ></div>
          <div style="padding-bottom: 1.5rem">
            @if (!editFormMode) {
              <div style="display: inline-block; width: 65.125rem">
                <span class="projectScopeSubHeader" style="font-size: 0.875rem"
                  >{{ itSponsor.givenName }} {{ itSponsor.surname }}, Sponsor</span
                >
              </div>
            }
            @if (editFormMode) {
              <div style="display: inline-block; width: 65.125rem">
                <span class="projectScopeSubHeader" style="font-size: 0.875rem"
                  >{{ itSponsorCopy.givenName }} {{ itSponsorCopy.surname }}, Sponsor</span
                >
              </div>
            }
            @if (!editFormMode) {
              <div style="display: inline-block; width: 4.125rem">
                <span class="projectScopeSubHeader" style="font-size: 0.875rem"
                  >${{ doaAmounts[0].toLocaleString('en', { useGrouping: true }) }}</span
                >
              </div>
            }
            @if (editFormMode) {
              <div style="display: inline-block; width: 4.125rem">
                <span class="projectScopeSubHeader" style="font-size: 0.875rem"
                  >${{ doaAmountsCopy[0].toLocaleString('en', { useGrouping: true }) }}</span
                >
              </div>
            }
          </div>
          @for (approver of approverList; track approver; let i = $index) {
            <div style="padding-bottom: 1.5rem">
              <div style="display: inline-block; width: 65.125rem">
                @if (approver.givenName && approver.surname && approver.jobTitle) {
                  <span class="projectScopeSubHeader" style="font-size: 0.875rem"
                    >{{ approver.givenName }} {{ approver.surname }} ({{ approver.mail }}),
                    {{ approver.jobTitle }}</span
                  >
                }
                @if (approver.givenName && approver.surname && !approver.jobTitle) {
                  <span class="projectScopeSubHeader" style="font-size: 0.875rem"
                    >{{ approver.givenName }} {{ approver.surname }} ({{ approver.mail }})</span
                  >
                }
                @if (!(approver.givenName && approver.surname) && approver.jobTitle) {
                  <span class="projectScopeSubHeader" style="font-size: 0.875rem"
                    >{{ approver.displayName }} ({{ approver.mail }}), {{ approver.jobTitle }}</span
                  >
                }
                @if (!(approver.givenName && approver.surname) && !approver.jobTitle) {
                  <span class="projectScopeSubHeader" style="font-size: 0.875rem"
                    >{{ approver.displayName }} ({{ approver.mail }})</span
                  >
                }
              </div>
              <div style="display: inline-block; width: 4.125rem">
                <span class="projectScopeSubHeader" style="font-size: 0.875rem"
                  >${{ doaAmounts[i + 1].toLocaleString('en', { useGrouping: true }) }}</span
                >
              </div>
            </div>
          }
        </div>
      </form>
      <div
        style="display: flex; justify-content: space-between; align-items: flex-start; width: 78rem"
      >
        <div style="margin-top: 2.625rem">
          <span class="itProjectHeader" style="font-size: 1.313rem"
            >Derivations and Allocations</span
          >
          <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
            <span class="projectScopeHeader">Form-Level Derivations</span>
            <div style="margin-top: 1.5rem; margin-bottom: 0.5rem"></div>
            <div class="form-container">
              <div
                class="form-column-header grey-border-bottom"
                style="width: 15rem !important; margin-right: 5rem"
              >
                Project Manager
              </div>
              <div
                class="form-column-header grey-border-bottom"
                style="width: 15rem !important; margin-right: 5rem"
              >
                Engineer
              </div>
              <div
                class="form-column-header grey-border-bottom"
                style="width: 15rem !important; margin-right: 5rem"
              >
                Contract Admin
              </div>
            </div>
            <div class="form-container">
              @if (derivationAndAllocations.projectManager) {
                <div class="form-column-text" style="width: 20rem !important">
                  {{ derivationAndAllocations.projectManager }}
                </div>
              }
              @if (derivationAndAllocations.engineer) {
                <div class="form-column-text" style="width: 20rem !important">
                  {{ derivationAndAllocations.engineer }}
                </div>
              }
              @if (derivationAndAllocations.contractAdmin) {
                <div class="form-column-text" style="width: 20rem !important">
                  {{ derivationAndAllocations.contractAdmin }}
                </div>
              }
            </div>
            <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
              <span class="projectScopeHeader">Project Notes:</span>
            </div>
            <div style="margin-top: 0.688rem">
              @if (!editFormMode) {
                <div class="p-1 grey-border text-grey width-60">
                  {{ getProjectNotes() }}
                </div>
              }
            </div>
          </div>
          <div style="margin-top: 1.5rem; margin-bottom: 1rem">
            <span class="projectScopeHeader">Project Specific Derivations</span>
            <div style="height: 0.5rem; padding-bottom: 5px"></div>
            <div>
              <div class="form-container grey-border-bottom" style="width: 82rem">
                <div class="form-column-header" style="width: 3rem !important">BU</div>
                <div class="form-column-header" style="width: 6rem !important">Project</div>
                <div class="form-column-header" style="width: 15rem !important">Major Location</div>
                <div class="form-column-header" style="width: 18rem !important">Asset Location</div>
                <div class="form-column-header" style="width: 18rem !important">Project Type</div>
                <div class="form-column-header" style="width: 7rem !important">
                  Project Charge Indicator
                </div>
                <div class="form-column-header" style="width: 7rem !important">
                  Joint Owner Code
                </div>
              </div>
              @for (project of itProjects; track project) {
                <div class="form-container">
                  <div class="form-column-text" style="width: 3rem !important">
                    {{ project.businessUnit }}
                  </div>
                  <div class="form-column-text" style="width: 6rem !important">
                    {{ project.projectID }}
                  </div>
                  @if (project.majorLocation) {
                    <div class="form-column-text" style="width: 15rem !important">
                      {{ project.majorLocation }}
                    </div>
                  }
                  @if (!project.majorLocation) {
                    <div class="form-column-text" style="width: 15rem !important; color: darkred">
                      Value could not be derived - Correct before proceeding
                    </div>
                  }
                  @if (project.assetLocation) {
                    <div class="form-column-text" style="width: 18rem !important">
                      {{ project.assetLocation }}
                    </div>
                  }
                  @if (!project.assetLocation) {
                    <div class="form-column-text" style="width: 18rem !important; color: darkred">
                      Value could not be derived - Correct before proceeding
                    </div>
                  }
                  <div class="form-column-text" style="width: 18rem !important">
                    {{ project.projectType }}
                  </div>
                  <div class="form-column-text" style="width: 7rem !important">
                    {{ project.projectChargeIndicator }}
                  </div>
                  @if (project.projectID.endsWith('C')) {
                    <div class="form-column-text" style="width: 7rem !important">CJOBASIC</div>
                  }
                </div>
              }
              <div style="height: 1rem; width: 50rem"></div>
              <span class="projectScopeHeader">Activities</span>
              <div style="height: 0.5rem; padding-bottom: 5px"></div>
              <div class="form-container grey-border-bottom" style="width: 40rem; margin-left: 0">
                <div class="form-column-header" style="width: 3rem !important">BU</div>
                <div class="form-column-header" style="width: 6rem !important">Project</div>
                <div class="form-column-header" style="width: 10rem !important">Activity</div>
                <div class="form-column-header" style="width: 10rem !important">Description</div>
                <div class="form-column-header" style="width: 10rem !important">
                  Accounting Model
                </div>
              </div>
              @for (project of itProjects; track project) {
                <div>
                  @if (project.activities.length > 0) {
                    @for (activity of project.activities; track activity; let i = $index) {
                      <div
                        class="form-container"
                        [ngStyle]="{
                          'margin-top':
                            i === 0 ||
                            project.activities[i - 1]?.businessUnit !== activity.businessUnit
                              ? '1rem'
                              : '0',
                        }"
                        style="width: 40rem; margin-left: 0"
                      >
                        <div class="form-column-text" style="width: 3rem !important">
                          {{ project.businessUnit }}
                        </div>
                        <div class="form-column-text" style="width: 6rem !important">
                          {{ project.projectID }}
                        </div>
                        <div class="form-column-text" style="width: 10rem !important">
                          {{ activity.activity }}
                        </div>
                        <div class="form-column-text" style="width: 10rem !important">
                          {{ activity.activityDescription }}
                        </div>
                        @if (activity.accountingModel) {
                          <div class="form-column-text" style="width: 10rem !important">
                            {{ activity.accountingModel }}
                          </div>
                        }
                        @if (!activity.accountingModel) {
                          <div
                            class="form-column-text"
                            style="width: 34rem !important; color: darkred"
                          >
                            Activity must be set up manually due to lack of an appropriate acctg
                            model.
                          </div>
                        }
                      </div>
                    }
                  }
                </div>
              }
            </div>
            <div style="margin-top: 1.5rem; margin-bottom: 0.5rem">
              <span class="projectScopeHeader">Project Estimates</span>
              <div style="height: 0.1rem; background-color: #f5f5f5"></div>
              @for (project of itProjects; track project) {
                <div class="gray-box">
                  <span>
                    <span class="static-form-text">BU:</span>
                    <span class="dynamic-form-text">{{ project.businessUnit }}</span>
                    <span class="static-form-text">Project:</span>
                    <span class="dynamic-form-text">{{ project.projectID }}</span>
                    <span class="static-form-text">Funding Project:</span>
                    <span class="dynamic-form-text">{{ project.fundingProjectID }}</span>
                    <span class="static-form-text">Percent:</span>
                    <span class="dynamic-form-text">{{ project.fundingProjectPercent }}</span>
                  </span>
                </div>
                @if (project.groupedEstimates) {
                  @for (group of project.groupedEstimates; track group) {
                    <div>
                      <div class="transparent-box">
                        <span>
                          <span class="static-form-text">Major Location:</span>
                          @if (group.majorLocation) {
                            <span class="dynamic-form-text"> {{ group.majorLocation }}</span>
                          }
                          @if (!group.majorLocation) {
                            <span class="dynamic-form-text" style="color: darkred">
                              Value could not be derived - Correct before proceeding</span
                            >
                          }
                          <span class="static-form-text">Asset Location:</span>
                          @if (group.assetLocation) {
                            <span class="dynamic-form-text"> {{ group.assetLocation }}</span>
                          }
                        </span>
                        @if (!group.assetLocation) {
                          <span class="dynamic-form-text" style="color: darkred">
                            Value could not be derived - Correct before proceeding</span
                          >
                        }
                        <div class="form-container grey-border-bottom" style="margin-top: 1rem">
                          <div class="form-column-header" style="width: 20rem !important">
                            Utility Account
                          </div>
                          <div class="form-column-header" style="width: 20rem !important">
                            Retirement Unit
                          </div>
                          <div class="form-column-header" style="width: 10rem !important">
                            Expenditure Type
                          </div>
                          <div class="form-column-header" style="width: 10rem !important">
                            Charge Type
                          </div>
                          <div
                            class="form-column-header"
                            style="width: 10rem !important; text-align: right !important"
                          >
                            Total Cost
                          </div>
                        </div>
                        @for (estimate of group.values; track estimate) {
                          <div class="form-container">
                            <div class="form-column-text" style="width: 20rem !important">
                              @if (estimate.utilityAccountDescription) {
                                <span>
                                  {{ estimate.utilityAccountDescription }}
                                </span>
                              }
                              @if (
                                !estimate.utilityAccountDescription &&
                                estimate.estimateType.includes('O&M')
                              ) {
                                <span> N/A </span>
                              }
                            </div>
                            <div class="form-column-text" style="width: 20rem !important">
                              @if (estimate.retirementUnitDescription) {
                                <span>
                                  {{ estimate.retirementUnitDescription }}
                                </span>
                              }
                              @if (
                                !estimate.retirementUnitDescription &&
                                estimate.estimateType.includes('O&M')
                              ) {
                                <span> N/A </span>
                              }
                            </div>
                            <div class="form-column-text" style="width: 10rem !important">
                              @if (
                                estimate.estimateType.includes('CAP') ||
                                estimate.estimateType.includes('AFUDC')
                              ) {
                                <span> Addition </span>
                              }
                              @if (estimate.estimateType.includes('Removal')) {
                                <span> Retirement </span>
                              }
                              @if (estimate.estimateType.includes('O&M')) {
                                <span> Expense </span>
                              }
                              @if (
                                !estimate.estimateType.includes('O&M') &&
                                !estimate.estimateType.includes('Removal') &&
                                !estimate.estimateType.includes('CAP') &&
                                !estimate.estimateType.includes('AFUDC')
                              ) {
                                <span> N/A </span>
                              }
                            </div>
                            <div class="form-column-text" style="width: 10rem !important">
                              {{ estimate.estimateType }}
                            </div>
                            <div
                              class="form-column-cost"
                              style="width: 10rem; text-align: right !important"
                            >
                              ${{
                                estimate.dollarAmount.toLocaleString('en', {
                                  useGrouping: true,
                                })
                              }}
                            </div>
                          </div>
                        }
                        <div class="form-container location-total-row">
                          <div
                            class="static-form-text"
                            style="width: 20rem !important; text-align: right; font-weight: 700"
                          >
                            Location Total:
                          </div>
                          <div
                            class="form-column-cost"
                            style="width: 13rem !important; padding-right: 30px; font-weight: 700"
                          >
                            ${{
                              group.locationCost.toLocaleString('en', {
                                useGrouping: true,
                              })
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                }
                <div class="location-total-row transparent-box">
                  <div
                    class="static-form-text"
                    style="width: 20rem !important; text-align: right; font-weight: 800"
                  >
                    Project Total:
                  </div>
                  @if (project.totalProjectCost) {
                    <div
                      class="form-column-cost"
                      style="width: 13.75rem !important; padding-right: 30px; font-weight: 800"
                    >
                      ${{
                        project.totalProjectCost.toLocaleString('en', {
                          useGrouping: true,
                        })
                      }}
                    </div>
                  }
                </div>
              }
              <div class="location-total-row transparent-box">
                <div
                  class="static-form-text"
                  style="width: 20rem !important; text-align: right; font-weight: 900"
                >
                  Grand Total:
                </div>
                <div
                  class="form-column-cost"
                  style="width: 14rem !important; padding-right: 30px; font-weight: 900"
                >
                  ${{
                    getGrandTotalCost().toLocaleString('en', {
                      useGrouping: true,
                    })
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (formActivityVisible) {
      <div
        style="
          top: 0rem;
          right: 0rem;
          background-color: #f5f6f6;
          height: auto;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          z-index: 1000;
          position: absolute;
          width: 30%;
          padding: 0rem;
        "
      >
        <div style="margin-left: 1.5rem; margin-top: 1.5rem">
          <div style="text-align: right; margin-bottom: -1.375rem; margin-right: 1.438rem">
            <span (click)="toggleFormActivity()" class="closeButton">&#10005;</span>
          </div>
          @if (readyForReview()) {
            <div style="margin-bottom: 1rem">
              <span style="font-size: 1.125rem; color: #4c4c4c"
                >The form is ready for your review.</span
              >
            </div>
          }
          @if (beingReviewed()) {
            <div style="margin-bottom: 1rem">
              <span style="font-size: 1.125rem; color: #4c4c4c">The form is being reviewed.</span>
            </div>
          }
          @if (youRejectedForm()) {
            <div style="margin-bottom: 1rem">
              <span style="font-size: 1.125rem; color: #4c4c4c">You have rejected the form.</span>
            </div>
          }
          @if (formRejected()) {
            <div style="margin-bottom: 1rem">
              <span style="font-size: 1.125rem; color: #4c4c4c">The form has been rejected.</span>
            </div>
          }
          @if (youApprovedForm()) {
            <div style="margin-bottom: 1rem">
              <span style="font-size: 1.125rem; color: #4c4c4c">You have approved the form.</span>
            </div>
          }
          @if (readyForCompletion()) {
            <div style="margin-bottom: 1rem">
              <span style="font-size: 1.125rem; color: #4c4c4c"
                >The form is approved and ready to be completed.</span
              >
            </div>
          }
          @if (youCompleted()) {
            <div style="margin-bottom: 1rem">
              <span style="font-size: 1.125rem; color: #4c4c4c">You have completed the form.</span>
            </div>
          }
          @if (formCompleted()) {
            <div style="margin-bottom: 1rem">
              <span style="font-size: 1.125rem; color: #4c4c4c">The form has been completed.</span>
            </div>
          }
          @if (awaitingJointOwner()) {
            <div style="margin-bottom: 1rem; width: 22.5rem">
              <span style="font-size: 1.125rem; color: #4c4c4c"
                >The form is awaiting Joint Owner approval. You may add charging details for
                approved projects.</span
              >
            </div>
          }
          @if (formCompletedSpecial) {
            <div style="margin-bottom: 1rem; width: 22.5rem">
              <span style="font-size: 1.125rem; color: #4c4c4c"
                >The form has been completed. Please see special notes.</span
              >
            </div>
          }
          @if (rejectedNeedingEdits()) {
            <div style="margin-bottom: 1rem; width: 22.5rem">
              <span style="font-size: 1.125rem; color: #4c4c4c"
                >The form has been rejected. Edit the form, save your changes and then resubmit it
                for review.</span
              >
            </div>
          }
          @if (formResubmitted()) {
            <div style="margin-bottom: 1rem; width: 22.5rem">
              <span style="font-size: 1.125rem; color: #4c4c4c"
                >The form has been resubmitted for review.</span
              >
            </div>
          }
          @if (readyForReview() || rejectedNeedingEdits()) {
            <div>
              <textarea
                [(ngModel)]="reviewComments"
                class="scopeDescriptionTextBox2"
                placeholder="Comments (optional)"
              ></textarea>
            </div>
          }
          @if (readyForReview()) {
            <div style="display: inline-block; padding-bottom: 1.5rem; margin-top: 1.25rem">
              <button (click)="approveForm(true)" class="rejectButton">
                <span class="confirmText">REJECT</span>
              </button>
            </div>
          }
          @if (readyForReview()) {
            <div style="display: inline-block; padding-bottom: 1.5rem">
              <button
                (click)="approveForm()"
                class="confirmButton"
                [class.buttonDisabled]="showDerivationError"
              >
                <span class="confirmText">APPROVE</span>
              </button>
            </div>
          }
          @if (readyForCompletion() && isCurrentApprover()) {
            <div style="display: inline-block; padding-bottom: 1.5rem">
              <button
                (click)="openChargingDetailsDialog(true)"
                class="confirmButton"
                style="width: 24rem"
              >
                <span class="confirmText">COMPLETE THE FORM</span>
              </button>
            </div>
          }
          @if (rejectedNeedingEdits()) {
            <div style="display: inline-block; padding-bottom: 1.5rem">
              <button
                (click)="approveForm(false, true, true, projectSetupForm, projectEstimateForm)"
                class="confirmButton"
                style="width: 24rem"
              >
                <span class="confirmText">RESUBMIT</span>
              </button>
            </div>
          }
          @if (awaitingJointOwner()) {
            <div style="display: inline-block; padding-bottom: 1.5rem">
              <button
                (click)="openChargingDetailsDialog()"
                class="confirmButton"
                style="width: 24rem"
              >
                <span class="confirmText">ADD CHARGING DETAILS</span>
              </button>
            </div>
          }
          <div style="height: 0.1rem; background-color: #b7b9ba; width: 25rem"></div>
          <div style="margin-bottom: 1rem; margin-top: 1.5rem">
            <span style="font-size: 1.125rem; color: #4c4c4c">Form Activity</span>
          </div>
          @for (activity of formActivity; track activity) {
            <div
              style="
                background-color: #ffffff;
                width: 24.062rem;
                padding-top: 0.875rem;
                padding-left: 0.938rem;
                margin-bottom: 1rem;
              "
            >
              <div style="display: inline-block">
                <span style="color: #4c4c4c">{{ activity.name }}</span>
              </div>
              <div style="display: inline-block; float: right; padding-right: 1.313rem">
                @if (activity.action === 'Submitted') {
                  <span style="color: #4c4c4c">{{ activity.action }}</span>
                }
                @if (activity.action === 'Approved') {
                  <span style="color: #00853f">{{ activity.action }}</span>
                }
                @if (activity.action === 'Approved') {
                  <img style="width: 1.063rem; margin-left: 0.313rem" src="assets/approved.svg" />
                }
                @if (activity.action === 'Rejected') {
                  <span style="color: #9e1b32">{{ activity.action }}</span>
                }
                @if (activity.action === 'Rejected') {
                  <img style="width: 1.063rem; margin-left: 0.313rem" src="assets/rejected.svg" />
                }
                @if (activity.action === 'Completed') {
                  <span style="color: #4c4c4c">{{ activity.action }}</span>
                }
                @if (activity.action === 'Completed') {
                  <img style="width: 1.063rem; margin-left: 0.313rem" src="assets/completed.svg" />
                }
                @if (activity.action === 'Added Charging Details') {
                  <span style="color: #4c4c4c; font-size: 0.875rem">{{ activity.action }}</span>
                }
                @if (activity.action === 'Made a Change') {
                  <span style="color: #4c4c4c; font-size: 0.875rem">{{ activity.action }}</span>
                }
                @if (activity.action === 'Resubmitted') {
                  <span style="color: #4c4c4c">{{ activity.action }}</span>
                }
              </div>
              <div>
                <span style="color: #696969; font-size: 0.875rem">
                  @if (activity.status) {
                    <span>
                      @if (activity.status === 'ET&S PAC Review') {
                        <span> <span style="font-weight: bold">ITPAC Review</span> - </span>
                      }
                      @if (activity.status === 'Lead ET&S PAC Review') {
                        <span> <span style="font-weight: bold">Lead ITPAC Review</span> - </span>
                      }
                      @if (activity.status === 'IT Sponsor Review') {
                        <span> <span style="font-weight: bold">Sponsor Review</span> - </span>
                      }
                      @if (activity.status.startsWith('DOA Review')) {
                        <span> <span style="font-weight: bold">DOA Review</span> - </span>
                      }
                      @if (
                        !(
                          activity.status === 'ET&S PAC Review' ||
                          activity.status === 'Lead ET&S PAC Review' ||
                          activity.status === 'IT Sponsor Review' ||
                          activity.status.startsWith('DOA Review')
                        )
                      ) {
                        <span>
                          <span style="font-weight: bold">{{ activity.status }}</span> -
                        </span>
                      }
                    </span>
                  }
                  {{ activity.time }}, {{ activity.day }}</span
                >
              </div>
              <div style="width: 95%; padding-bottom: 1rem">
                <span style="color: #4c4c4c; font-size: 0.875rem">{{ activity.comment }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}

<!-- Email Templates -->

<!-- Charging Details Email Template -->
<div id="email_template_charging_email" class="email_templates">
  <div style="margin: auto; text-align: center; width: 42.75rem">
    <div style="text-align: left">
      <span style="font-size: 0.875rem"> $firstName </span>
    </div>
  </div>
  <p style="font-size: 0.875rem">
    Charging details have been added for
    <a href="$redirectUrl" style="font-size: 0.875rem">$formInfo</a>.
  </p>

  <p style="font-weight: bold; font-size: 14px">Effective Date $effectiveDate</p>

  <section>
    @for (table of tables; track table; let tableIndex = $index) {
      <div style="margin-bottom: 20px">
        <span style="font-weight: bold; font-size: 14px">{{ table.tableName }}</span>
        <div>
          <table style="border: 1px solid #696969; border-collapse: collapse; width: fit-content">
            @for (column of getColumnDefs(tableIndex); track column; let columnIndex = $index) {
              <th
                style="
                  padding: 0px;
                  border-width: 1px;
                  border-style: inset;
                  width: 200px;
                  height: 54px;
                  font-size: 16px;
                  color: #696969;
                  text-align: center;
                  vertical-align: middle;
                  font-weight: bold;
                "
              >
                {{ table.columns[columnIndex].colName }}
              </th>
            }
            @for (row of table.tableData; track row; let rowIndex = $index) {
              <tr>
                @for (column of getColumnDefs(tableIndex); track column; let columnIndex = $index) {
                  <td
                    style="
                      padding: 0px;
                      border-width: 1px;
                      border-style: inset;
                      width: 200px;
                      height: 48px;
                      font-size: 16px;
                      color: #696969;
                      text-align: center;
                      vertical-align: middle;
                    "
                  >
                    {{ getRowValue(tableIndex, rowIndex, columnIndex) }}
                  </td>
                }
              </tr>
            }
          </table>
        </div>
      </div>
    }
  </section>

  <p style="font-size: 0.875rem">Please click below to view the charging details on the form.</p>

  <div style="margin: auto; text-align: center">
    <a href="$redirectUrl">
      <span
        style="
          width: 300px;
          background: rgb(0, 120, 158);
          border-radius: 0.125rem;
          display: inline-block;
          cursor: pointer;
          color: white;
          text-decoration: none;
          text-align: center;
          padding-top: 10px;
          padding-bottom: 10px;
        "
      >
        VIEW THE FORM
      </span>
    </a>
  </div>
</div>

<!-- Form Completed Email Template -->
<div id="email_template_form_completed" class="email_templates">
  <div style="margin: auto; text-align: center; width: 42.75rem">
    <div style="text-align: left">
      <span style="font-size: 0.875rem"> $firstName </span>
    </div>
  </div>
  <p style="font-size: 0.875rem">
    The <a href="$redirectUrl" style="font-size: 0.875rem">$formInfo</a> has been completed. See
    below for more information.
  </p>

  <p style="font-weight: bold; font-size: 14px">Effective Date $effectiveDate</p>

  <section>
    @for (table of tables; track table; let tableIndex = $index) {
      <div style="margin-bottom: 20px">
        <span style="font-weight: bold; font-size: 14px">{{ table.tableName }}</span>
        <div>
          <table style="border: 1px solid #696969; border-collapse: collapse; width: fit-content">
            @for (column of getColumnDefs(tableIndex); track column; let columnIndex = $index) {
              <th
                style="
                  padding: 0px;
                  border-width: 1px;
                  border-style: inset;
                  width: 200px;
                  height: 54px;
                  font-size: 16px;
                  color: #696969;
                  text-align: center;
                  vertical-align: middle;
                  font-weight: bold;
                "
              >
                {{ table.columns[columnIndex].colName }}
              </th>
            }
            @for (row of table.tableData; track row; let rowIndex = $index) {
              <tr>
                @for (column of getColumnDefs(tableIndex); track column; let columnIndex = $index) {
                  <td
                    style="
                      padding: 0px;
                      border-width: 1px;
                      border-style: inset;
                      width: 200px;
                      height: 48px;
                      font-size: 16px;
                      color: #696969;
                      text-align: center;
                      vertical-align: middle;
                    "
                  >
                    {{ getRowValue(tableIndex, rowIndex, columnIndex) }}
                  </td>
                }
              </tr>
            }
          </table>
        </div>
      </div>
    }
  </section>

  <p style="font-weight: bold; font-size: 14px">Comments</p>
  <p style="font-weight: bold; font-size: 14px">$comments</p>

  <p style="font-size: 0.875rem">Please click below to view the charging details on the form.</p>

  <div style="margin: auto; text-align: center">
    <a href="$redirectUrl">
      <span
        style="
          width: 300px;
          background: rgb(0, 120, 158);
          border-radius: 0.125rem;
          display: inline-block;
          cursor: pointer;
          color: white;
          text-decoration: none;
          text-align: center;
          padding-top: 10px;
          padding-bottom: 10px;
        "
      >
        VIEW THE FORM
      </span>
    </a>
  </div>
</div>
